<template>
  <div class="chart" :class="{ small: isSmall }">
    <strong>
      Kvantpunkt ja selle tekitatav valgus
    </strong>

    <div class="lead">
      Mida väiksem kvantpunktina toimiv nano-osake, seda vähem on elektronil ruumi sinna ära mahtuda ja seda lühem on sellele osakesele ära mahtuva elektroni laine pikkus ja seda sinisem on valgus, mida see tekitab. Elektronide liikumisega on määratud materjalide optilised omadused.
    </div>

    <main>
      <div style="top: -1.1em; left: 3%;">
        ELEKTRONI LAINE
      </div>

      <div style="top: 30%; left: 3%;">
        Suurem kvantpunkt:<br />
        rohkem ruumi elektronile
      </div>

      <div style="top: 30%; right: 3%; text-align: right;">
        Väiksem kvantpunkt:<br />
        vähem ruumi elektronile
      </div>

      <div class="content-2">
        Kvantpunkt käitub nagu omapärane vahejaam: neelab valguse ja muudab selle energia siis uueks valguseks, mille lainepikkus sõltub sellest, kui palju on elektronidel ruumi sellise osakese peal liikuda.
      </div>
      
<svg viewBox="0 0 408.9 336.9">

<g>
  <g>
    <line class="st0" x1="20.4" y1="90.9" x2="390.5" y2="90.9"/>
    <g>
      <polygon class="st1" points="21.6,94.9 14.7,90.9 21.6,86.9      "/>
    </g>
    <g>
      <polygon class="st1" points="389.3,94.9 396.3,90.9 389.3,86.9       "/>
    </g>
  </g>
</g>
<g>
  <circle class="st2" cx="375.5" cy="47.3" r="18.1"/>
  <circle class="st2" cx="375.5" cy="47.3" r="18"/>
  <circle class="st3" cx="375.5" cy="47.3" r="17.8"/>
  <circle class="st4" cx="375.5" cy="47.3" r="17.7"/>
  <circle class="st4" cx="375.5" cy="47.3" r="17.6"/>
  <circle class="st5" cx="375.5" cy="47.3" r="17.5"/>
  <circle class="st5" cx="375.5" cy="47.3" r="17.3"/>
  <circle class="st6" cx="375.5" cy="47.3" r="17.2"/>
  <circle class="st6" cx="375.5" cy="47.3" r="17.1"/>
  <circle class="st6" cx="375.5" cy="47.3" r="16.9"/>
  <circle class="st7" cx="375.5" cy="47.3" r="16.8"/>
  <circle class="st7" cx="375.5" cy="47.3" r="16.7"/>
  <circle class="st8" cx="375.5" cy="47.3" r="16.5"/>
  <circle class="st8" cx="375.5" cy="47.3" r="16.4"/>
  <circle class="st9" cx="375.5" cy="47.3" r="16.3"/>
  <circle class="st9" cx="375.5" cy="47.3" r="16.1"/>
  <circle class="st10" cx="375.5" cy="47.3" r="16"/>
  <circle class="st11" cx="375.5" cy="47.3" r="15.9"/>
  <circle class="st11" cx="375.5" cy="47.3" r="15.7"/>
  <circle class="st12" cx="375.5" cy="47.3" r="15.6"/>
  <circle class="st12" cx="375.5" cy="47.3" r="15.5"/>
  <circle class="st13" cx="375.5" cy="47.3" r="15.3"/>
  <circle class="st13" cx="375.5" cy="47.3" r="15.2"/>
  <circle class="st13" cx="375.5" cy="47.3" r="15.1"/>
  <circle class="st14" cx="375.5" cy="47.3" r="15"/>
  <circle class="st15" cx="375.5" cy="47.3" r="14.8"/>
  <circle class="st16" cx="375.5" cy="47.3" r="14.7"/>
  <circle class="st16" cx="375.5" cy="47.3" r="14.6"/>
  <circle class="st17" cx="375.5" cy="47.3" r="14.4"/>
  <circle class="st18" cx="375.5" cy="47.3" r="14.3"/>
  <circle class="st18" cx="375.5" cy="47.3" r="14.2"/>
  <circle class="st19" cx="375.5" cy="47.3" r="14"/>
  <circle class="st19" cx="375.5" cy="47.3" r="13.9"/>
  <circle class="st20" cx="375.5" cy="47.3" r="13.8"/>
  <circle class="st21" cx="375.5" cy="47.3" r="13.6"/>
  <circle class="st22" cx="375.5" cy="47.3" r="13.5"/>
  <circle class="st22" cx="375.5" cy="47.3" r="13.4"/>
  <circle class="st23" cx="375.5" cy="47.3" r="13.2"/>
  <circle class="st24" cx="375.5" cy="47.3" r="13.1"/>
  <circle class="st24" cx="375.5" cy="47.3" r="13"/>
  <circle class="st25" cx="375.5" cy="47.3" r="12.8"/>
  <circle class="st26" cx="375.5" cy="47.3" r="12.7"/>
  <circle class="st27" cx="375.5" cy="47.3" r="12.6"/>
  <circle class="st27" cx="375.5" cy="47.3" r="12.5"/>
  <circle class="st28" cx="375.5" cy="47.3" r="12.3"/>
  <circle class="st29" cx="375.5" cy="47.3" r="12.2"/>
  <circle class="st30" cx="375.5" cy="47.3" r="12.1"/>
  <circle class="st30" cx="375.5" cy="47.3" r="11.9"/>
  <circle class="st30" cx="375.5" cy="47.3" r="11.8"/>
  <circle class="st31" cx="375.5" cy="47.3" r="11.7"/>
  <circle class="st31" cx="375.5" cy="47.3" r="11.5"/>
  <circle class="st32" cx="375.5" cy="47.3" r="11.4"/>
  <circle class="st32" cx="375.5" cy="47.3" r="11.3"/>
  <circle class="st33" cx="375.5" cy="47.3" r="11.1"/>
  <circle class="st33" cx="375.5" cy="47.3" r="11"/>
  <circle class="st34" cx="375.5" cy="47.3" r="10.9"/>
  <circle class="st34" cx="375.5" cy="47.3" r="10.7"/>
  <circle class="st35" cx="375.5" cy="47.3" r="10.6"/>
  <circle class="st36" cx="375.5" cy="47.3" r="10.5"/>
  <circle class="st36" cx="375.5" cy="47.3" r="10.3"/>
  <circle class="st37" cx="375.5" cy="47.3" r="10.2"/>
  <circle class="st37" cx="375.5" cy="47.3" r="10.1"/>
  <circle class="st38" cx="375.5" cy="47.3" r="10"/>
  <circle class="st39" cx="375.5" cy="47.3" r="9.8"/>
  <circle class="st40" cx="375.5" cy="47.3" r="9.7"/>
  <circle class="st40" cx="375.5" cy="47.3" r="9.6"/>
  <circle class="st41" cx="375.5" cy="47.3" r="9.4"/>
  <circle class="st41" cx="375.5" cy="47.3" r="9.3"/>
  <circle class="st42" cx="375.5" cy="47.3" r="9.2"/>
  <circle class="st42" cx="375.5" cy="47.3" r="9"/>
  <circle class="st43" cx="375.5" cy="47.3" r="8.9"/>
  <circle class="st43" cx="375.5" cy="47.3" r="8.8"/>
  <circle class="st44" cx="375.5" cy="47.3" r="8.6"/>
  <circle class="st45" cx="375.5" cy="47.3" r="8.5"/>
  <circle class="st45" cx="375.5" cy="47.3" r="8.4"/>
  <circle class="st46" cx="375.5" cy="47.3" r="8.2"/>
  <circle class="st46" cx="375.5" cy="47.3" r="8.1"/>
  <circle class="st47" cx="375.5" cy="47.3" r="8"/>
  <circle class="st48" cx="375.5" cy="47.3" r="7.8"/>
  <circle class="st49" cx="375.5" cy="47.3" r="7.7"/>
  <circle class="st50" cx="375.5" cy="47.3" r="7.6"/>
  <circle class="st51" cx="375.5" cy="47.3" r="7.4"/>
  <circle class="st52" cx="375.5" cy="47.3" r="7.3"/>
  <circle class="st53" cx="375.5" cy="47.3" r="7.2"/>
  <circle class="st54" cx="375.5" cy="47.3" r="7.1"/>
  <circle class="st55" cx="375.5" cy="47.3" r="6.9"/>
  <circle class="st56" cx="375.5" cy="47.3" r="6.8"/>
  <circle class="st57" cx="375.5" cy="47.3" r="6.7"/>
  <circle class="st58" cx="375.5" cy="47.3" r="6.5"/>
  <circle class="st59" cx="375.5" cy="47.3" r="6.4"/>
  <circle class="st60" cx="375.5" cy="47.3" r="6.3"/>
  <circle class="st61" cx="375.5" cy="47.3" r="6.1"/>
  <circle class="st62" cx="375.5" cy="47.3" r="6"/>
  <circle class="st63" cx="375.5" cy="47.3" r="5.9"/>
  <circle class="st64" cx="375.5" cy="47.3" r="5.7"/>
  <circle class="st65" cx="375.5" cy="47.3" r="5.6"/>
  <circle class="st66" cx="375.5" cy="47.3" r="5.5"/>
  <circle class="st67" cx="375.5" cy="47.3" r="5.3"/>
  <circle class="st68" cx="375.5" cy="47.3" r="5.2"/>
</g>
<g>
  <circle class="st69" cx="310" cy="47.3" r="21.8"/>
  <circle class="st70" cx="310" cy="47.3" r="21.6"/>
  <circle class="st71" cx="310" cy="47.3" r="21.5"/>
  <circle class="st72" cx="310" cy="47.3" r="21.3"/>
  <circle class="st73" cx="310" cy="47.3" r="21.1"/>
  <circle class="st74" cx="310" cy="47.3" r="20.9"/>
  <circle class="st75" cx="310" cy="47.3" r="20.7"/>
  <circle class="st76" cx="310" cy="47.3" r="20.6"/>
  <circle class="st77" cx="310" cy="47.3" r="20.4"/>
  <circle class="st78" cx="310" cy="47.3" r="20.2"/>
  <circle class="st79" cx="310" cy="47.3" r="20"/>
  <circle class="st80" cx="310" cy="47.3" r="19.8"/>
  <circle class="st81" cx="310" cy="47.3" r="19.7"/>
  <circle class="st82" cx="310" cy="47.3" r="19.5"/>
  <circle class="st83" cx="310" cy="47.3" r="19.3"/>
  <circle class="st84" cx="310" cy="47.3" r="19.1"/>
  <circle class="st85" cx="310" cy="47.3" r="19"/>
  <circle class="st86" cx="310" cy="47.3" r="18.8"/>
  <circle class="st87" cx="310" cy="47.3" r="18.6"/>
  <circle class="st88" cx="310" cy="47.3" r="18.4"/>
  <circle class="st89" cx="310" cy="47.3" r="18.2"/>
  <circle class="st90" cx="310" cy="47.3" r="18.1"/>
  <circle class="st91" cx="310" cy="47.3" r="17.9"/>
  <circle class="st92" cx="310" cy="47.3" r="17.7"/>
  <circle class="st93" cx="310" cy="47.3" r="17.5"/>
  <circle class="st94" cx="310" cy="47.3" r="17.3"/>
  <circle class="st95" cx="310" cy="47.3" r="17.2"/>
  <circle class="st96" cx="310" cy="47.3" r="17"/>
  <circle class="st97" cx="310" cy="47.3" r="16.8"/>
  <circle class="st98" cx="310" cy="47.3" r="16.6"/>
  <circle class="st99" cx="310" cy="47.3" r="16.4"/>
  <circle class="st100" cx="310" cy="47.3" r="16.3"/>
  <circle class="st101" cx="310" cy="47.3" r="16.1"/>
  <circle class="st102" cx="310" cy="47.3" r="15.9"/>
  <circle class="st103" cx="310" cy="47.3" r="15.7"/>
  <circle class="st104" cx="310" cy="47.3" r="15.5"/>
  <circle class="st105" cx="310" cy="47.3" r="15.4"/>
  <circle class="st106" cx="310" cy="47.3" r="15.2"/>
  <circle class="st107" cx="310" cy="47.3" r="15"/>
  <circle class="st108" cx="310" cy="47.3" r="14.8"/>
  <circle class="st109" cx="310" cy="47.3" r="14.6"/>
  <circle class="st110" cx="310" cy="47.3" r="14.5"/>
  <circle class="st111" cx="310" cy="47.3" r="14.3"/>
  <circle class="st112" cx="310" cy="47.3" r="14.1"/>
  <circle class="st113" cx="310" cy="47.3" r="13.9"/>
  <circle class="st114" cx="310" cy="47.3" r="13.8"/>
  <circle class="st115" cx="310" cy="47.3" r="13.6"/>
  <circle class="st116" cx="310" cy="47.3" r="13.4"/>
  <circle class="st117" cx="310" cy="47.3" r="13.2"/>
  <circle class="st118" cx="310" cy="47.3" r="13"/>
  <circle class="st119" cx="310" cy="47.3" r="12.9"/>
  <circle class="st120" cx="310" cy="47.3" r="12.7"/>
  <circle class="st121" cx="310" cy="47.3" r="12.5"/>
  <circle class="st122" cx="310" cy="47.3" r="12.3"/>
  <circle class="st123" cx="310" cy="47.3" r="12.1"/>
  <circle class="st124" cx="310" cy="47.3" r="12"/>
  <circle class="st125" cx="310" cy="47.3" r="11.8"/>
  <circle class="st126" cx="310" cy="47.3" r="11.6"/>
  <circle class="st127" cx="310" cy="47.3" r="11.4"/>
  <circle class="st128" cx="310" cy="47.3" r="11.2"/>
  <circle class="st129" cx="310" cy="47.3" r="11.1"/>
  <circle class="st130" cx="310" cy="47.3" r="10.9"/>
  <circle class="st131" cx="310" cy="47.3" r="10.7"/>
  <circle class="st132" cx="310" cy="47.3" r="10.5"/>
  <circle class="st133" cx="310" cy="47.3" r="10.3"/>
  <circle class="st134" cx="310" cy="47.3" r="10.2"/>
  <circle class="st135" cx="310" cy="47.3" r="10"/>
  <circle class="st136" cx="310" cy="47.3" r="9.8"/>
  <circle class="st137" cx="310" cy="47.3" r="9.6"/>
  <circle class="st138" cx="310" cy="47.3" r="9.4"/>
  <circle class="st139" cx="310" cy="47.3" r="9.3"/>
  <circle class="st140" cx="310" cy="47.3" r="9.1"/>
  <circle class="st141" cx="310" cy="47.3" r="8.9"/>
  <circle class="st142" cx="310" cy="47.3" r="8.7"/>
  <circle class="st143" cx="310" cy="47.3" r="8.6"/>
  <circle class="st144" cx="310" cy="47.3" r="8.4"/>
  <circle class="st145" cx="310" cy="47.3" r="8.2"/>
  <circle class="st146" cx="310" cy="47.3" r="8"/>
  <circle class="st147" cx="310" cy="47.3" r="7.8"/>
  <circle class="st148" cx="310" cy="47.3" r="7.7"/>
  <circle class="st149" cx="310" cy="47.3" r="7.5"/>
  <circle class="st150" cx="310" cy="47.3" r="7.3"/>
  <circle class="st151" cx="310" cy="47.3" r="7.1"/>
  <circle class="st152" cx="310" cy="47.3" r="6.9"/>
  <circle class="st153" cx="310" cy="47.3" r="6.8"/>
  <circle class="st154" cx="310" cy="47.3" r="6.6"/>
  <circle class="st155" cx="310" cy="47.3" r="6.4"/>
  <circle class="st156" cx="310" cy="47.3" r="6.2"/>
  <circle class="st157" cx="310" cy="47.3" r="6"/>
  <circle class="st158" cx="310" cy="47.3" r="5.9"/>
  <circle class="st159" cx="310" cy="47.3" r="5.7"/>
  <circle class="st160" cx="310" cy="47.3" r="5.5"/>
  <circle class="st161" cx="310" cy="47.3" r="5.3"/>
  <circle class="st162" cx="310" cy="47.3" r="5.1"/>
  <circle class="st163" cx="310" cy="47.3" r="5"/>
</g>
<g>
  <circle class="st164" cx="234.3" cy="47.3" r="26.1"/>
  <circle class="st165" cx="234.3" cy="47.3" r="25.6"/>
  <circle class="st166" cx="234.3" cy="47.3" r="25.2"/>
  <circle class="st167" cx="234.3" cy="47.3" r="24.8"/>
  <circle class="st167" cx="234.3" cy="47.3" r="24.4"/>
  <circle class="st168" cx="234.3" cy="47.3" r="24"/>
  <circle class="st169" cx="234.3" cy="47.3" r="23.5"/>
  <circle class="st170" cx="234.3" cy="47.3" r="23.1"/>
  <circle class="st171" cx="234.3" cy="47.3" r="22.7"/>
  <circle class="st172" cx="234.3" cy="47.3" r="22.3"/>
  <circle class="st173" cx="234.3" cy="47.3" r="21.8"/>
  <circle class="st174" cx="234.3" cy="47.3" r="21.4"/>
  <circle class="st175" cx="234.3" cy="47.3" r="21"/>
  <circle class="st176" cx="234.3" cy="47.3" r="20.6"/>
  <circle class="st177" cx="234.3" cy="47.3" r="20.2"/>
  <circle class="st178" cx="234.3" cy="47.3" r="19.7"/>
  <circle class="st179" cx="234.3" cy="47.3" r="19.3"/>
  <circle class="st179" cx="234.3" cy="47.3" r="18.9"/>
  <circle class="st180" cx="234.3" cy="47.3" r="18.5"/>
  <circle class="st181" cx="234.3" cy="47.3" r="18"/>
  <circle class="st182" cx="234.3" cy="47.3" r="17.6"/>
  <circle class="st183" cx="234.3" cy="47.3" r="17.2"/>
  <circle class="st184" cx="234.3" cy="47.3" r="16.8"/>
  <circle class="st185" cx="234.3" cy="47.3" r="16.3"/>
  <circle class="st186" cx="234.3" cy="47.3" r="15.9"/>
  <circle class="st187" cx="234.3" cy="47.3" r="15.5"/>
  <circle class="st188" cx="234.3" cy="47.3" r="15.1"/>
  <circle class="st189" cx="234.3" cy="47.3" r="14.7"/>
  <circle class="st189" cx="234.3" cy="47.3" r="14.2"/>
  <circle class="st190" cx="234.3" cy="47.3" r="13.8"/>
  <circle class="st191" cx="234.3" cy="47.3" r="13.4"/>
  <circle class="st192" cx="234.3" cy="47.3" r="13"/>
  <circle class="st193" cx="234.3" cy="47.3" r="12.5"/>
  <circle class="st194" cx="234.3" cy="47.3" r="12.1"/>
  <circle class="st195" cx="234.3" cy="47.3" r="11.7"/>
  <circle class="st196" cx="234.3" cy="47.3" r="11.3"/>
  <circle class="st197" cx="234.3" cy="47.3" r="10.8"/>
  <circle class="st197" cx="234.3" cy="47.3" r="10.4"/>
  <circle class="st198" cx="234.3" cy="47.3" r="10"/>
  <circle class="st199" cx="234.3" cy="47.3" r="9.6"/>
  <circle class="st199" cx="234.3" cy="47.3" r="9.2"/>
  <circle class="st200" cx="234.3" cy="47.3" r="8.7"/>
  <circle class="st200" cx="234.3" cy="47.3" r="8.3"/>
  <circle class="st200" cx="234.3" cy="47.3" r="7.9"/>
  <circle class="st201" cx="234.3" cy="47.3" r="7.5"/>
  <circle class="st201" cx="234.3" cy="47.3" r="7"/>
  <circle class="st201" cx="234.3" cy="47.3" r="6.6"/>
  <circle class="st202" cx="234.3" cy="47.3" r="6.2"/>
  <circle class="st202" cx="234.3" cy="47.3" r="5.8"/>
  <circle class="st202" cx="234.3" cy="47.3" r="5.4"/>
</g>
<g>
  <circle class="st203" cx="149.1" cy="47.3" r="31.1"/>
  <circle class="st204" cx="149.1" cy="47.3" r="30.8"/>
  <circle class="st204" cx="149.1" cy="47.3" r="30.5"/>
  <circle class="st205" cx="149.1" cy="47.3" r="30.2"/>
  <circle class="st206" cx="149.1" cy="47.3" r="29.9"/>
  <circle class="st206" cx="149.1" cy="47.3" r="29.7"/>
  <circle class="st207" cx="149.1" cy="47.3" r="29.4"/>
  <circle class="st208" cx="149.1" cy="47.3" r="29.1"/>
  <circle class="st208" cx="149.1" cy="47.3" r="28.8"/>
  <circle class="st209" cx="149.1" cy="47.3" r="28.5"/>
  <circle class="st210" cx="149.1" cy="47.3" r="28.2"/>
  <circle class="st211" cx="149.1" cy="47.3" r="27.9"/>
  <circle class="st212" cx="149.1" cy="47.3" r="27.6"/>
  <circle class="st213" cx="149.1" cy="47.3" r="27.3"/>
  <circle class="st213" cx="149.1" cy="47.3" r="27.1"/>
  <circle class="st214" cx="149.1" cy="47.3" r="26.8"/>
  <circle class="st215" cx="149.1" cy="47.3" r="26.5"/>
  <circle class="st215" cx="149.1" cy="47.3" r="26.2"/>
  <circle class="st216" cx="149.1" cy="47.3" r="25.9"/>
  <circle class="st217" cx="149.1" cy="47.3" r="25.6"/>
  <circle class="st218" cx="149.1" cy="47.3" r="25.3"/>
  <circle class="st219" cx="149.1" cy="47.3" r="25"/>
  <circle class="st220" cx="149.1" cy="47.3" r="24.7"/>
  <circle class="st220" cx="149.1" cy="47.3" r="24.5"/>
  <circle class="st221" cx="149.1" cy="47.3" r="24.2"/>
  <circle class="st222" cx="149.1" cy="47.3" r="23.9"/>
  <circle class="st222" cx="149.1" cy="47.3" r="23.6"/>
  <circle class="st223" cx="149.1" cy="47.3" r="23.3"/>
  <circle class="st224" cx="149.1" cy="47.3" r="23"/>
  <circle class="st225" cx="149.1" cy="47.3" r="22.7"/>
  <circle class="st226" cx="149.1" cy="47.3" r="22.4"/>
  <circle class="st227" cx="149.1" cy="47.3" r="22.1"/>
  <circle class="st227" cx="149.1" cy="47.3" r="21.9"/>
  <circle class="st228" cx="149.1" cy="47.3" r="21.6"/>
  <circle class="st229" cx="149.1" cy="47.3" r="21.3"/>
  <circle class="st229" cx="149.1" cy="47.3" r="21"/>
  <circle class="st230" cx="149.1" cy="47.3" r="20.7"/>
  <circle class="st231" cx="149.1" cy="47.3" r="20.4"/>
  <circle class="st231" cx="149.1" cy="47.3" r="20.1"/>
  <circle class="st232" cx="149.1" cy="47.3" r="19.8"/>
  <circle class="st233" cx="149.1" cy="47.3" r="19.5"/>
  <circle class="st233" cx="149.1" cy="47.3" r="19.3"/>
  <circle class="st234" cx="149.1" cy="47.3" r="19"/>
  <circle class="st235" cx="149.1" cy="47.3" r="18.7"/>
  <circle class="st236" cx="149.1" cy="47.3" r="18.4"/>
  <circle class="st236" cx="149.1" cy="47.3" r="18.1"/>
  <circle class="st237" cx="149.1" cy="47.3" r="17.8"/>
  <circle class="st238" cx="149.1" cy="47.3" r="17.5"/>
  <circle class="st238" cx="149.1" cy="47.3" r="17.2"/>
  <circle class="st239" cx="149.1" cy="47.3" r="16.9"/>
  <circle class="st240" cx="149.1" cy="47.3" r="16.7"/>
  <circle class="st240" cx="149.1" cy="47.3" r="16.4"/>
  <circle class="st241" cx="149.1" cy="47.3" r="16.1"/>
  <circle class="st242" cx="149.1" cy="47.3" r="15.8"/>
  <circle class="st242" cx="149.1" cy="47.3" r="15.5"/>
  <circle class="st243" cx="149.1" cy="47.3" r="15.2"/>
  <circle class="st244" cx="149.1" cy="47.3" r="14.9"/>
  <circle class="st244" cx="149.1" cy="47.3" r="14.6"/>
  <circle class="st245" cx="149.1" cy="47.3" r="14.3"/>
  <circle class="st246" cx="149.1" cy="47.3" r="14"/>
  <circle class="st247" cx="149.1" cy="47.3" r="13.8"/>
  <circle class="st248" cx="149.1" cy="47.3" r="13.5"/>
  <circle class="st248" cx="149.1" cy="47.3" r="13.2"/>
  <circle class="st249" cx="149.1" cy="47.3" r="12.9"/>
  <circle class="st250" cx="149.1" cy="47.3" r="12.6"/>
  <circle class="st250" cx="149.1" cy="47.3" r="12.3"/>
  <circle class="st251" cx="149.1" cy="47.3" r="12"/>
  <circle class="st252" cx="149.1" cy="47.3" r="11.7"/>
  <circle class="st252" cx="149.1" cy="47.3" r="11.4"/>
  <circle class="st253" cx="149.1" cy="47.3" r="11.2"/>
  <circle class="st253" cx="149.1" cy="47.3" r="10.9"/>
  <circle class="st254" cx="149.1" cy="47.3" r="10.6"/>
  <circle class="st255" cx="149.1" cy="47.3" r="10.3"/>
  <circle class="st255" cx="149.1" cy="47.3" r="10"/>
  <circle class="st256" cx="149.1" cy="47.3" r="9.7"/>
  <circle class="st257" cx="149.1" cy="47.3" r="9.4"/>
  <circle class="st257" cx="149.1" cy="47.3" r="9.1"/>
  <circle class="st258" cx="149.1" cy="47.3" r="8.8"/>
  <circle class="st259" cx="149.1" cy="47.3" r="8.6"/>
  <circle class="st259" cx="149.1" cy="47.3" r="8.3"/>
</g>
<g>
  <circle class="st260" cx="50.8" cy="47.3" r="36.5"/>
  <circle class="st261" cx="50.8" cy="47.3" r="36.2"/>
  <circle class="st262" cx="50.8" cy="47.3" r="36"/>
  <circle class="st263" cx="50.8" cy="47.3" r="35.8"/>
  <circle class="st264" cx="50.8" cy="47.3" r="35.6"/>
  <circle class="st265" cx="50.8" cy="47.3" r="35.3"/>
  <circle class="st266" cx="50.8" cy="47.3" r="35.1"/>
  <circle class="st267" cx="50.8" cy="47.3" r="34.9"/>
  <circle class="st268" cx="50.8" cy="47.3" r="34.7"/>
  <circle class="st269" cx="50.8" cy="47.3" r="34.4"/>
  <circle class="st270" cx="50.8" cy="47.3" r="34.2"/>
  <circle class="st271" cx="50.8" cy="47.3" r="34"/>
  <circle class="st272" cx="50.8" cy="47.3" r="33.8"/>
  <circle class="st273" cx="50.8" cy="47.3" r="33.5"/>
  <circle class="st274" cx="50.8" cy="47.3" r="33.3"/>
  <circle class="st275" cx="50.8" cy="47.3" r="33.1"/>
  <circle class="st276" cx="50.8" cy="47.3" r="32.9"/>
  <circle class="st277" cx="50.8" cy="47.3" r="32.6"/>
  <circle class="st278" cx="50.8" cy="47.3" r="32.4"/>
  <circle class="st279" cx="50.8" cy="47.3" r="32.2"/>
  <circle class="st280" cx="50.8" cy="47.3" r="32"/>
  <circle class="st281" cx="50.8" cy="47.3" r="31.7"/>
  <circle class="st282" cx="50.8" cy="47.3" r="31.5"/>
  <circle class="st283" cx="50.8" cy="47.3" r="31.3"/>
  <circle class="st284" cx="50.8" cy="47.3" r="31.1"/>
  <circle class="st285" cx="50.8" cy="47.3" r="30.8"/>
  <circle class="st286" cx="50.8" cy="47.3" r="30.6"/>
  <circle class="st287" cx="50.8" cy="47.3" r="30.4"/>
  <circle class="st288" cx="50.8" cy="47.3" r="30.2"/>
  <circle class="st289" cx="50.8" cy="47.3" r="29.9"/>
  <circle class="st290" cx="50.8" cy="47.3" r="29.7"/>
  <circle class="st291" cx="50.8" cy="47.3" r="29.5"/>
  <circle class="st292" cx="50.8" cy="47.3" r="29.3"/>
  <circle class="st293" cx="50.8" cy="47.3" r="29"/>
  <circle class="st294" cx="50.8" cy="47.3" r="28.8"/>
  <circle class="st295" cx="50.8" cy="47.3" r="28.6"/>
  <circle class="st296" cx="50.8" cy="47.3" r="28.4"/>
  <circle class="st297" cx="50.8" cy="47.3" r="28.1"/>
  <circle class="st298" cx="50.8" cy="47.3" r="27.9"/>
  <circle class="st299" cx="50.8" cy="47.3" r="27.7"/>
  <circle class="st300" cx="50.8" cy="47.3" r="27.5"/>
  <circle class="st301" cx="50.8" cy="47.3" r="27.2"/>
  <circle class="st302" cx="50.8" cy="47.3" r="27"/>
  <circle class="st303" cx="50.8" cy="47.3" r="26.8"/>
  <circle class="st304" cx="50.8" cy="47.3" r="26.6"/>
  <circle class="st305" cx="50.8" cy="47.3" r="26.3"/>
  <circle class="st306" cx="50.8" cy="47.3" r="26.1"/>
  <circle class="st307" cx="50.8" cy="47.3" r="25.9"/>
  <circle class="st308" cx="50.8" cy="47.3" r="25.7"/>
  <circle class="st308" cx="50.8" cy="47.3" r="25.4"/>
  <circle class="st309" cx="50.8" cy="47.3" r="25.2"/>
  <circle class="st310" cx="50.8" cy="47.3" r="25"/>
  <circle class="st311" cx="50.8" cy="47.3" r="24.8"/>
  <circle class="st312" cx="50.8" cy="47.3" r="24.5"/>
  <circle class="st313" cx="50.8" cy="47.3" r="24.3"/>
  <circle class="st314" cx="50.8" cy="47.3" r="24.1"/>
  <circle class="st315" cx="50.8" cy="47.3" r="23.9"/>
  <circle class="st316" cx="50.8" cy="47.3" r="23.6"/>
  <circle class="st317" cx="50.8" cy="47.3" r="23.4"/>
  <circle class="st318" cx="50.8" cy="47.3" r="23.2"/>
  <circle class="st319" cx="50.8" cy="47.3" r="23"/>
  <circle class="st320" cx="50.8" cy="47.3" r="22.7"/>
  <circle class="st321" cx="50.8" cy="47.3" r="22.5"/>
  <circle class="st322" cx="50.8" cy="47.3" r="22.3"/>
  <circle class="st323" cx="50.8" cy="47.3" r="22.1"/>
  <circle class="st324" cx="50.8" cy="47.3" r="21.8"/>
  <circle class="st325" cx="50.8" cy="47.3" r="21.6"/>
  <circle class="st326" cx="50.8" cy="47.3" r="21.4"/>
  <circle class="st327" cx="50.8" cy="47.3" r="21.2"/>
  <circle class="st328" cx="50.8" cy="47.3" r="20.9"/>
  <circle class="st329" cx="50.8" cy="47.3" r="20.7"/>
  <circle class="st330" cx="50.8" cy="47.3" r="20.5"/>
  <circle class="st331" cx="50.8" cy="47.3" r="20.3"/>
  <circle class="st332" cx="50.8" cy="47.3" r="20"/>
  <circle class="st333" cx="50.8" cy="47.3" r="19.8"/>
  <circle class="st334" cx="50.8" cy="47.3" r="19.6"/>
  <circle class="st335" cx="50.8" cy="47.3" r="19.4"/>
  <circle class="st336" cx="50.8" cy="47.3" r="19.1"/>
  <circle class="st337" cx="50.8" cy="47.3" r="18.9"/>
  <circle class="st338" cx="50.8" cy="47.3" r="18.7"/>
  <circle class="st339" cx="50.8" cy="47.3" r="18.5"/>
  <circle class="st340" cx="50.8" cy="47.3" r="18.2"/>
  <circle class="st341" cx="50.8" cy="47.3" r="18"/>
  <circle class="st341" cx="50.8" cy="47.3" r="17.8"/>
  <circle class="st342" cx="50.8" cy="47.3" r="17.6"/>
  <circle class="st343" cx="50.8" cy="47.3" r="17.3"/>
  <circle class="st344" cx="50.8" cy="47.3" r="17.1"/>
  <circle class="st345" cx="50.8" cy="47.3" r="16.9"/>
  <circle class="st346" cx="50.8" cy="47.3" r="16.7"/>
  <circle class="st347" cx="50.8" cy="47.3" r="16.4"/>
  <circle class="st348" cx="50.8" cy="47.3" r="16.2"/>
  <circle class="st349" cx="50.8" cy="47.3" r="16"/>
  <circle class="st350" cx="50.8" cy="47.3" r="15.8"/>
  <circle class="st351" cx="50.8" cy="47.3" r="15.5"/>
  <circle class="st352" cx="50.8" cy="47.3" r="15.3"/>
  <circle class="st353" cx="50.8" cy="47.3" r="15.1"/>
  <circle class="st353" cx="50.8" cy="47.3" r="14.9"/>
  <circle class="st354" cx="50.8" cy="47.3" r="14.6"/>
  <circle class="st355" cx="50.8" cy="47.3" r="14.4"/>
  <circle class="st356" cx="50.8" cy="47.3" r="14.2"/>
  <circle class="st357" cx="50.8" cy="47.3" r="14"/>
  <circle class="st358" cx="50.8" cy="47.3" r="13.7"/>
  <circle class="st359" cx="50.8" cy="47.3" r="13.5"/>
  <circle class="st360" cx="50.8" cy="47.3" r="13.3"/>
  <circle class="st361" cx="50.8" cy="47.3" r="13.1"/>
  <circle class="st361" cx="50.8" cy="47.3" r="12.8"/>
  <circle class="st362" cx="50.8" cy="47.3" r="12.6"/>
  <circle class="st363" cx="50.8" cy="47.3" r="12.4"/>
  <circle class="st364" cx="50.8" cy="47.3" r="12.2"/>
  <circle class="st365" cx="50.8" cy="47.3" r="11.9"/>
  <circle class="st366" cx="50.8" cy="47.3" r="11.7"/>
  <circle class="st367" cx="50.8" cy="47.3" r="11.5"/>
  <circle class="st368" cx="50.8" cy="47.3" r="11.3"/>
  <circle class="st369" cx="50.8" cy="47.3" r="11"/>
  <circle class="st370" cx="50.8" cy="47.3" r="10.8"/>
  <circle class="st371" cx="50.8" cy="47.3" r="10.6"/>
  <circle class="st372" cx="50.8" cy="47.3" r="10.4"/>
  <circle class="st373" cx="50.8" cy="47.3" r="10.1"/>
  <circle class="st374" cx="50.8" cy="47.3" r="9.9"/>
  <circle class="st375" cx="50.8" cy="47.3" r="9.7"/>
  <circle class="st376" cx="50.8" cy="47.3" r="9.5"/>
  <circle class="st377" cx="50.8" cy="47.3" r="9.2"/>
  <circle class="st378" cx="50.8" cy="47.3" r="9"/>
  <circle class="st378" cx="50.8" cy="47.3" r="8.8"/>
  <circle class="st379" cx="50.8" cy="47.3" r="8.6"/>
  <circle class="st380" cx="50.8" cy="47.3" r="8.3"/>
  <circle class="st381" cx="50.8" cy="47.3" r="8.1"/>
  <circle class="st382" cx="50.8" cy="47.3" r="7.9"/>
  <circle class="st383" cx="50.8" cy="47.3" r="7.7"/>
  <circle class="st384" cx="50.8" cy="47.3" r="7.4"/>
  <circle class="st385" cx="50.8" cy="47.3" r="7.2"/>
  <circle class="st386" cx="50.8" cy="47.3" r="7"/>
</g>
<g>
  <defs>
    <circle id="SVGID_1_" cx="375.5" cy="47.3" r="18.1"/>
  </defs>

  <clipPath id="SVGID_00000130636937538594824220000006068401980559533460_">
    <use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
  </clipPath>
  
    <path style="clip-path:url(#SVGID_00000130636937538594824220000006068401980559533460_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;" d="
    M475.5,36.3c-9.1,0-9.1,24.1-18.3,24.1c-9.1,0-9.1-24.1-18.3-24.1c-9.1,0-9.1,24.1-18.3,24.1c-9.1,0-9.1-24.1-18.3-24.1
    c-9.1,0-9.1,24.1-18.3,24.1c-9.1,0-9.1-24.1-18.2-24.1c-9.1,0-9.1,24.1-18.3,24.1c-9.1,0-9.1-24.1-18.3-24.1
    c-9.1,0-9.1,24.1-18.3,24.1c-9.1,0-9.1-24.1-18.3-24.1s-9.1,24.1-18.3,24.1"/>
</g>
<g>
  <defs>
    <circle id="SVGID_00000183216364879324807140000006708870511951299982_" cx="310" cy="47.3" r="21.8"/>
  </defs>
  <clipPath id="SVGID_00000134967948544157056940000014158817188902897062_">
    <use xlink:href="#SVGID_00000183216364879324807140000006708870511951299982_"  style="overflow:visible;"/>
  </clipPath>
  
    <path style="clip-path:url(#SVGID_00000134967948544157056940000014158817188902897062_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;" d="
    M475.8,36.3c-11.1,0-11.1,24.1-22.2,24.1c-11.1,0-11.1-24.1-22.2-24.1c-11.1,0-11.1,24.1-22.2,24.1c-11.1,0-11.1-24.1-22.2-24.1
    c-11.1,0-11.1,24.1-22.2,24.1c-11.1,0-11.1-24.1-22.2-24.1c-11.1,0-11.1,24.1-22.2,24.1c-11.1,0-11.1-24.1-22.2-24.1
    c-11.1,0-11.1,24.1-22.2,24.1c-11.1,0-11.1-24.1-22.2-24.1c-11.1,0-11.1,24.1-22.2,24.1"/>
</g>
<g>
  <defs>
    <circle id="SVGID_00000127015227266964448580000007169785798212316858_" cx="234.3" cy="47.3" r="26.1"/>
  </defs>
  <clipPath id="SVGID_00000105396928496871570600000002177942157134092932_">
    <use xlink:href="#SVGID_00000127015227266964448580000007169785798212316858_"  style="overflow:visible;"/>
  </clipPath>
  
    <path style="clip-path:url(#SVGID_00000105396928496871570600000002177942157134092932_);fill:none;stroke:#1C1B18;stroke-width:0.997;stroke-miterlimit:10;" d="
    M377.7,36.3c-13.1,0-13.1,24.1-26.1,24.1c-13.1,0-13.1-24.1-26.1-24.1c-13.1,0-13.1,24.1-26.1,24.1c-13.1,0-13.1-24.1-26.1-24.1
    c-13.1,0-13.1,24.1-26.1,24.1c-13.1,0-13.1-24.1-26.1-24.1c-13.1,0-13.1,24.1-26.1,24.1c-13.1,0-13.1-24.1-26.1-24.1
    c-13.1,0-13.1,24.1-26.1,24.1c-13.1,0-13.1-24.1-26.2-24.1s-13.1,24.1-26.2,24.1"/>
</g>
<g>
  <defs>
    <circle id="SVGID_00000074417312310352451100000006258151669661828517_" cx="149.1" cy="47.3" r="31.1"/>
  </defs>
  <clipPath id="SVGID_00000156548969327281804750000003905463845929062285_">
    <use xlink:href="#SVGID_00000074417312310352451100000006258151669661828517_"  style="overflow:visible;"/>
  </clipPath>
  
    <path style="clip-path:url(#SVGID_00000156548969327281804750000003905463845929062285_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;" d="
    M320.2,36.3c-15.6,0-15.6,24.1-31.2,24.1c-15.6,0-15.6-24.1-31.2-24.1c-15.6,0-15.6,24.1-31.2,24.1c-15.6,0-15.6-24.1-31.2-24.1
    c-15.6,0-15.6,24.1-31.2,24.1c-15.6,0-15.6-24.1-31.2-24.1c-15.6,0-15.6,24.1-31.2,24.1c-15.6,0-15.6-24.1-31.2-24.1
    c-15.6,0-15.6,24.1-31.2,24.1C23.6,60.4,23.6,36.3,8,36.3S-7.6,60.4-23.3,60.4"/>
</g>
<g>
  <defs>
    <circle id="SVGID_00000016755023400361734660000000652056935151940497_" cx="50.8" cy="47.3" r="36.5"/>
  </defs>
  <clipPath id="SVGID_00000034770327980898722380000004492680870809707188_">
    <use xlink:href="#SVGID_00000016755023400361734660000000652056935151940497_"  style="overflow:visible;"/>
  </clipPath>
  
    <path style="clip-path:url(#SVGID_00000034770327980898722380000004492680870809707188_);fill:none;stroke:#1C1B18;stroke-width:0.9958;stroke-miterlimit:10;" d="
    M250.2,36.3c-18.2,0-18.2,24.1-36.4,24.1c-18.2,0-18.2-24.1-36.4-24.1c-18.2,0-18.2,24.1-36.4,24.1c-18.2,0-18.2-24.1-36.4-24.1
    c-18.2,0-18.2,24.1-36.4,24.1c-18.2,0-18.2-24.1-36.4-24.1c-18.2,0-18.2,24.1-36.4,24.1c-18.2,0-18.2-24.1-36.4-24.1
    C-59,36.3-59,60.4-77.2,60.4c-18.2,0-18.2-24.1-36.4-24.1s-18.2,24.1-36.4,24.1"/>
</g>
<circle class="st1" cx="374.6" cy="47.4" r="3"/>
<circle class="st1" cx="309.1" cy="47.4" r="3"/>
<circle class="st1" cx="147.7" cy="47.4" r="3"/>
<circle class="st1" cx="233.3" cy="47.4" r="3"/>
<circle class="st1" cx="49.2" cy="47.4" r="3"/>
<line class="st392" x1="0" y1="36.3" x2="405" y2="36.3"/>
<line class="st392" x1="0" y1="60.3" x2="405" y2="60.3"/>
<g>
  <g>
    <g>
      <path class="st393" d="M322.2,248.4c2,4.7-9.1,9.5-7.1,14.3c2,4.7,13.2-0.1,15.2,4.6c2,4.7-9.1,9.5-7.1,14.3
        c2,4.7,13.2-0.1,15.2,4.6c2,4.7-9.1,9.5-7.1,14.3"/>
      <path class="st393" d="M331.4,300.5c2,4.7,13.2-0.1,15.2,4.6c0.8,1.9-0.5,3.8-2.2,5.7c-0.8,0.9-1,2.2-0.5,3.3l2.2,4.5"/>
      <g>
        <g>
          <circle class="st203" cx="311.8" cy="239.3" r="15.7"/>
          <circle class="st204" cx="311.8" cy="239.3" r="15.5"/>
          <circle class="st394" cx="311.8" cy="239.3" r="15.3"/>
          <circle class="st395" cx="311.8" cy="239.3" r="15.2"/>
          <circle class="st396" cx="311.8" cy="239.3" r="15"/>
          <circle class="st397" cx="311.8" cy="239.3" r="14.9"/>
          <circle class="st398" cx="311.8" cy="239.3" r="14.7"/>
          <circle class="st399" cx="311.8" cy="239.3" r="14.5"/>
          <circle class="st400" cx="311.8" cy="239.3" r="14.4"/>
          <circle class="st401" cx="311.8" cy="239.3" r="14.2"/>
          <circle class="st402" cx="311.8" cy="239.3" r="14.1"/>
          <circle class="st403" cx="311.8" cy="239.3" r="13.9"/>
          <circle class="st404" cx="311.8" cy="239.3" r="13.7"/>
          <circle class="st405" cx="311.8" cy="239.3" r="13.6"/>
          <circle class="st406" cx="311.8" cy="239.3" r="13.4"/>
          <circle class="st407" cx="311.8" cy="239.3" r="13.3"/>
          <circle class="st407" cx="311.8" cy="239.3" r="13.1"/>
          <circle class="st408" cx="311.8" cy="239.3" r="12.9"/>
          <circle class="st409" cx="311.8" cy="239.3" r="12.8"/>
          <circle class="st410" cx="311.8" cy="239.3" r="12.6"/>
          <circle class="st411" cx="311.8" cy="239.3" r="12.5"/>
          <circle class="st412" cx="311.8" cy="239.3" r="12.3"/>
          <circle class="st413" cx="311.8" cy="239.3" r="12.1"/>
          <circle class="st413" cx="311.8" cy="239.3" r="12"/>
          <circle class="st414" cx="311.8" cy="239.3" r="11.8"/>
          <circle class="st415" cx="311.8" cy="239.3" r="11.7"/>
          <circle class="st416" cx="311.8" cy="239.3" r="11.5"/>
          <circle class="st417" cx="311.8" cy="239.3" r="11.3"/>
          <circle class="st418" cx="311.8" cy="239.3" r="11.2"/>
          <circle class="st419" cx="311.8" cy="239.3" r="11"/>
          <circle class="st420" cx="311.8" cy="239.3" r="10.9"/>
          <circle class="st421" cx="311.8" cy="239.3" r="10.7"/>
          <circle class="st422" cx="311.8" cy="239.3" r="10.5"/>
          <circle class="st423" cx="311.8" cy="239.3" r="10.4"/>
          <circle class="st424" cx="311.8" cy="239.3" r="10.2"/>
          <circle class="st425" cx="311.8" cy="239.3" r="10.1"/>
          <circle class="st426" cx="311.8" cy="239.3" r="9.9"/>
          <circle class="st427" cx="311.8" cy="239.3" r="9.7"/>
          <circle class="st428" cx="311.8" cy="239.3" r="9.6"/>
          <circle class="st429" cx="311.8" cy="239.3" r="9.4"/>
          <circle class="st430" cx="311.8" cy="239.3" r="9.3"/>
          <circle class="st431" cx="311.8" cy="239.3" r="9.1"/>
          <circle class="st432" cx="311.8" cy="239.3" r="8.9"/>
          <circle class="st433" cx="311.8" cy="239.3" r="8.8"/>
          <circle class="st433" cx="311.8" cy="239.3" r="8.6"/>
          <circle class="st434" cx="311.8" cy="239.3" r="8.5"/>
          <circle class="st435" cx="311.8" cy="239.3" r="8.3"/>
          <circle class="st436" cx="311.8" cy="239.3" r="8.1"/>
          <circle class="st437" cx="311.8" cy="239.3" r="8"/>
          <circle class="st438" cx="311.8" cy="239.3" r="7.8"/>
          <circle class="st439" cx="311.8" cy="239.3" r="7.7"/>
          <circle class="st440" cx="311.8" cy="239.3" r="7.5"/>
          <circle class="st441" cx="311.8" cy="239.3" r="7.3"/>
          <circle class="st442" cx="311.8" cy="239.3" r="7.2"/>
          <circle class="st443" cx="311.8" cy="239.3" r="7"/>
          <circle class="st444" cx="311.8" cy="239.3" r="6.9"/>
          <circle class="st445" cx="311.8" cy="239.3" r="6.7"/>
          <circle class="st446" cx="311.8" cy="239.3" r="6.5"/>
          <circle class="st447" cx="311.8" cy="239.3" r="6.4"/>
          <circle class="st448" cx="311.8" cy="239.3" r="6.2"/>
          <circle class="st449" cx="311.8" cy="239.3" r="6.1"/>
          <circle class="st450" cx="311.8" cy="239.3" r="5.9"/>
          <circle class="st451" cx="311.8" cy="239.3" r="5.7"/>
          <circle class="st452" cx="311.8" cy="239.3" r="5.6"/>
          <circle class="st453" cx="311.8" cy="239.3" r="5.4"/>
          <circle class="st454" cx="311.8" cy="239.3" r="5.3"/>
          <circle class="st455" cx="311.8" cy="239.3" r="5.1"/>
          <circle class="st456" cx="311.8" cy="239.3" r="4.9"/>
          <circle class="st457" cx="311.8" cy="239.3" r="4.8"/>
          <circle class="st458" cx="311.8" cy="239.3" r="4.6"/>
          <circle class="st459" cx="311.8" cy="239.3" r="4.5"/>
          <circle class="st460" cx="311.8" cy="239.3" r="4.3"/>
          <circle class="st461" cx="311.8" cy="239.3" r="4.1"/>
          <circle class="st461" cx="311.8" cy="239.3" r="4"/>
          <circle class="st462" cx="311.8" cy="239.3" r="3.8"/>
          <circle class="st463" cx="311.8" cy="239.3" r="3.7"/>
          <circle class="st464" cx="311.8" cy="239.3" r="3.5"/>
          <circle class="st465" cx="311.8" cy="239.3" r="3.3"/>
          <circle class="st466" cx="311.8" cy="239.3" r="3.2"/>
          <circle class="st467" cx="311.8" cy="239.3" r="3"/>
        </g>
      </g>
      <polygon class="st468" points="341.7,319.4 348,321.5 350,315.2      "/>
    </g>
    <g>
      <path class="st469" d="M284.6,254.1c0,3.2-12.1,3.2-12.1,6.4c0,3.2,12.1,3.2,12.1,6.4c0,3.2-12.1,3.2-12.1,6.4
        c0,3.2,12.1,3.2,12.1,6.4c0,3.2-12.1,3.2-12.1,6.4c0,3.2,12.1,3.2,12.1,6.4c0,3.2-12.1,3.2-12.1,6.4c0,3.2,12.1,3.2,12.1,6.4"/>
      <path class="st469" d="M284.7,305.3c0,3.2-12.1,3.2-12.1,6.4c0,3.2,12.1,3.2,12.1,6.4c0,3.2-12.1,3.2-12.1,6.4
        c0,1.5,2.5,2.2,5.2,3c0.7,0.2,1.2,0.8,1.2,1.5l0.1,5.1"/>
      <g>
        <g>
          <circle class="st470" cx="278.9" cy="243.2" r="13.1"/>
          <circle class="st471" cx="278.9" cy="243.2" r="13"/>
          <circle class="st472" cx="278.9" cy="243.2" r="12.9"/>
          <circle class="st472" cx="278.9" cy="243.2" r="12.8"/>
          <circle class="st473" cx="278.9" cy="243.2" r="12.6"/>
          <circle class="st473" cx="278.9" cy="243.2" r="12.5"/>
          <circle class="st473" cx="278.9" cy="243.2" r="12.4"/>
          <circle class="st474" cx="278.9" cy="243.2" r="12.3"/>
          <circle class="st475" cx="278.9" cy="243.2" r="12.1"/>
          <circle class="st476" cx="278.9" cy="243.2" r="12"/>
          <circle class="st476" cx="278.9" cy="243.2" r="11.9"/>
          <circle class="st476" cx="278.9" cy="243.2" r="11.8"/>
          <circle class="st477" cx="278.9" cy="243.2" r="11.6"/>
          <circle class="st477" cx="278.9" cy="243.2" r="11.5"/>
          <circle class="st478" cx="278.9" cy="243.2" r="11.4"/>
          <circle class="st479" cx="278.9" cy="243.2" r="11.3"/>
          <circle class="st479" cx="278.9" cy="243.2" r="11.1"/>
          <circle class="st480" cx="278.9" cy="243.2" r="11"/>
          <circle class="st481" cx="278.9" cy="243.2" r="10.9"/>
          <circle class="st482" cx="278.9" cy="243.2" r="10.8"/>
          <circle class="st483" cx="278.9" cy="243.2" r="10.7"/>
          <circle class="st484" cx="278.9" cy="243.2" r="10.5"/>
          <circle class="st485" cx="278.9" cy="243.2" r="10.4"/>
          <circle class="st486" cx="278.9" cy="243.2" r="10.3"/>
          <circle class="st487" cx="278.9" cy="243.2" r="10.2"/>
          <circle class="st488" cx="278.9" cy="243.2" r="10"/>
          <circle class="st489" cx="278.9" cy="243.2" r="9.9"/>
          <circle class="st490" cx="278.9" cy="243.2" r="9.8"/>
          <circle class="st491" cx="278.9" cy="243.2" r="9.7"/>
          <circle class="st492" cx="278.9" cy="243.2" r="9.5"/>
          <circle class="st493" cx="278.9" cy="243.2" r="9.4"/>
          <circle class="st494" cx="278.9" cy="243.2" r="9.3"/>
          <circle class="st495" cx="278.9" cy="243.2" r="9.2"/>
          <circle class="st496" cx="278.9" cy="243.2" r="9"/>
          <circle class="st497" cx="278.9" cy="243.2" r="8.9"/>
          <circle class="st498" cx="278.9" cy="243.2" r="8.8"/>
          <circle class="st499" cx="278.9" cy="243.2" r="8.7"/>
          <circle class="st500" cx="278.9" cy="243.2" r="8.5"/>
          <circle class="st501" cx="278.9" cy="243.2" r="8.4"/>
          <circle class="st502" cx="278.9" cy="243.2" r="8.3"/>
          <circle class="st503" cx="278.9" cy="243.2" r="8.2"/>
          <circle class="st504" cx="278.9" cy="243.2" r="8"/>
          <circle class="st505" cx="278.9" cy="243.2" r="7.9"/>
          <circle class="st506" cx="278.9" cy="243.2" r="7.8"/>
          <circle class="st507" cx="278.9" cy="243.2" r="7.7"/>
          <circle class="st508" cx="278.9" cy="243.2" r="7.5"/>
          <circle class="st509" cx="278.9" cy="243.2" r="7.4"/>
          <circle class="st510" cx="278.9" cy="243.2" r="7.3"/>
          <circle class="st511" cx="278.9" cy="243.2" r="7.2"/>
          <circle class="st512" cx="278.9" cy="243.2" r="7"/>
          <circle class="st513" cx="278.9" cy="243.2" r="6.9"/>
          <circle class="st514" cx="278.9" cy="243.2" r="6.8"/>
          <circle class="st515" cx="278.9" cy="243.2" r="6.7"/>
          <circle class="st516" cx="278.9" cy="243.2" r="6.6"/>
          <circle class="st517" cx="278.9" cy="243.2" r="6.4"/>
          <circle class="st518" cx="278.9" cy="243.2" r="6.3"/>
          <circle class="st519" cx="278.9" cy="243.2" r="6.2"/>
          <circle class="st520" cx="278.9" cy="243.2" r="6.1"/>
          <circle class="st521" cx="278.9" cy="243.2" r="5.9"/>
          <circle class="st522" cx="278.9" cy="243.2" r="5.8"/>
          <circle class="st523" cx="278.9" cy="243.2" r="5.7"/>
          <circle class="st524" cx="278.9" cy="243.2" r="5.6"/>
          <circle class="st525" cx="278.9" cy="243.2" r="5.4"/>
          <circle class="st526" cx="278.9" cy="243.2" r="5.3"/>
          <circle class="st527" cx="278.9" cy="243.2" r="5.2"/>
          <circle class="st528" cx="278.9" cy="243.2" r="5.1"/>
          <circle class="st529" cx="278.9" cy="243.2" r="4.9"/>
          <circle class="st530" cx="278.9" cy="243.2" r="4.8"/>
          <circle class="st531" cx="278.9" cy="243.2" r="4.7"/>
          <circle class="st532" cx="278.9" cy="243.2" r="4.6"/>
          <circle class="st533" cx="278.9" cy="243.2" r="4.4"/>
          <circle class="st534" cx="278.9" cy="243.2" r="4.3"/>
          <circle class="st535" cx="278.9" cy="243.2" r="4.2"/>
          <circle class="st536" cx="278.9" cy="243.2" r="4.1"/>
          <circle class="st537" cx="278.9" cy="243.2" r="3.9"/>
          <circle class="st538" cx="278.9" cy="243.2" r="3.8"/>
          <circle class="st539" cx="278.9" cy="243.2" r="3.7"/>
          <circle class="st540" cx="278.9" cy="243.2" r="3.6"/>
          <circle class="st541" cx="278.9" cy="243.2" r="3.4"/>
          <circle class="st542" cx="278.9" cy="243.2" r="3.3"/>
          <circle class="st543" cx="278.9" cy="243.2" r="3.2"/>
          <circle class="st544" cx="278.9" cy="243.2" r="3.1"/>
          <circle class="st545" cx="278.9" cy="243.2" r="2.9"/>
          <circle class="st546" cx="278.9" cy="243.2" r="2.8"/>
          <circle class="st547" cx="278.9" cy="243.2" r="2.7"/>
          <circle class="st548" cx="278.9" cy="243.2" r="2.6"/>
          <circle class="st549" cx="278.9" cy="243.2" r="2.5"/>
          <circle class="st550" cx="278.9" cy="243.2" r="2.3"/>
          <circle class="st551" cx="278.9" cy="243.2" r="2.2"/>
          <circle class="st552" cx="278.9" cy="243.2" r="2.1"/>
          <circle class="st553" cx="278.9" cy="243.2" r="2"/>
        </g>
      </g>
      <polygon class="st554" points="274.3,332.2 279,336.9 283.7,332.2      "/>
    </g>
    <g>
      <path class="st555" d="M251.1,244.2c-1,2.1-11.9-2.4-12.9-0.3c-1,2.1,9.9,7.4,8.9,9.5c-1,2.1-11.9-3.3-12.9-1.2
        c-1,2.1,9.9,7.4,8.9,9.5c-1,2.1-11.9-3.3-12.9-1.2c-1,2.1,9.9,7.4,8.9,9.5c-1,2.1-11.9-3.3-12.9-1.2c-1,2.1,9.9,7.4,8.9,9.5
        c-1,2.1-11.9-3.3-12.9-1.2c-1,2.1,9.9,7.4,8.9,9.5c-1,2.1-11.9-3.2-12.9-1.2"/>
      <path class="st555" d="M213.8,293.9c-0.4,0.8,1.1,2.2,3,3.7c0.8,0.6,1.1,1.7,0.7,2.7l-0.8,1.7"/>
      <path class="st555" d="M217.8,285.5c-1,2.1,9.9,7.4,8.9,9.5c-1,2.1-11.9-3.3-12.9-1.2"/>
      <g>
        <g>
          <circle class="st69" cx="250.9" cy="234.8" r="11"/>
          <circle class="st70" cx="250.9" cy="234.9" r="10.8"/>
          <circle class="st71" cx="250.9" cy="234.9" r="10.7"/>
          <circle class="st72" cx="250.9" cy="234.9" r="10.5"/>
          <circle class="st73" cx="250.9" cy="234.9" r="10.4"/>
          <circle class="st74" cx="250.9" cy="234.9" r="10.2"/>
          <circle class="st75" cx="250.9" cy="234.9" r="10.1"/>
          <circle class="st76" cx="250.9" cy="234.9" r="9.9"/>
          <circle class="st77" cx="250.9" cy="234.9" r="9.8"/>
          <circle class="st78" cx="250.8" cy="234.9" r="9.6"/>
          <circle class="st79" cx="250.8" cy="234.9" r="9.5"/>
          <circle class="st556" cx="250.8" cy="234.9" r="9.3"/>
          <circle class="st81" cx="250.8" cy="234.9" r="9.2"/>
          <circle class="st82" cx="250.8" cy="234.9" r="9"/>
          <circle class="st83" cx="250.8" cy="234.9" r="8.9"/>
          <circle class="st84" cx="250.8" cy="234.9" r="8.7"/>
          <circle class="st85" cx="250.8" cy="234.9" r="8.6"/>
          <circle class="st86" cx="250.7" cy="235" r="8.4"/>
          <circle class="st87" cx="250.7" cy="235" r="8.3"/>
          <circle class="st88" cx="250.7" cy="235" r="8.1"/>
          <circle class="st89" cx="250.7" cy="235" r="8"/>
          <circle class="st90" cx="250.7" cy="235" r="7.8"/>
          <circle class="st91" cx="250.7" cy="235" r="7.7"/>
          <circle class="st92" cx="250.7" cy="235" r="7.5"/>
          <circle class="st93" cx="250.7" cy="235" r="7.4"/>
          <circle class="st94" cx="250.7" cy="235" r="7.2"/>
          <circle class="st95" cx="250.6" cy="235" r="7.1"/>
          <circle class="st96" cx="250.6" cy="235" r="6.9"/>
          <circle class="st97" cx="250.6" cy="235" r="6.8"/>
          <circle class="st98" cx="250.6" cy="235" r="6.6"/>
          <circle class="st99" cx="250.6" cy="235" r="6.5"/>
          <circle class="st100" cx="250.6" cy="235" r="6.3"/>
          <circle class="st101" cx="250.6" cy="235" r="6.2"/>
          <circle class="st102" cx="250.6" cy="235" r="6"/>
          <circle class="st103" cx="250.5" cy="235.1" r="5.9"/>
          <circle class="st104" cx="250.5" cy="235.1" r="5.7"/>
          <circle class="st105" cx="250.5" cy="235.1" r="5.6"/>
          <circle class="st106" cx="250.5" cy="235.1" r="5.4"/>
          <circle class="st107" cx="250.5" cy="235.1" r="5.3"/>
          <circle class="st108" cx="250.5" cy="235.1" r="5.1"/>
          <circle class="st109" cx="250.5" cy="235.1" r="5"/>
          <circle class="st110" cx="250.5" cy="235.1" r="4.8"/>
          <circle class="st111" cx="250.5" cy="235.1" r="4.7"/>
          <circle class="st557" cx="250.4" cy="235.1" r="4.5"/>
          <circle class="st113" cx="250.4" cy="235.1" r="4.4"/>
          <circle class="st114" cx="250.4" cy="235.1" r="4.2"/>
          <circle class="st115" cx="250.4" cy="235.1" r="4.1"/>
          <circle class="st116" cx="250.4" cy="235.1" r="3.9"/>
          <circle class="st117" cx="250.4" cy="235.1" r="3.8"/>
          <circle class="st118" cx="250.4" cy="235.1" r="3.6"/>
          <circle class="st119" cx="250.4" cy="235.1" r="3.5"/>
          <circle class="st120" cx="250.3" cy="235.2" r="3.3"/>
          <circle class="st121" cx="250.3" cy="235.2" r="3.1"/>
          <circle class="st122" cx="250.3" cy="235.2" r="3"/>
          <circle class="st123" cx="250.3" cy="235.2" r="2.8"/>
          <circle class="st124" cx="250.3" cy="235.2" r="2.7"/>
          <circle class="st125" cx="250.3" cy="235.2" r="2.5"/>
          <circle class="st558" cx="250.3" cy="235.2" r="2.4"/>
          <circle class="st127" cx="250.3" cy="235.2" r="2.2"/>
          <circle class="st128" cx="250.2" cy="235.2" r="2.1"/>
          <circle class="st559" cx="250.2" cy="235.2" r="1.9"/>
          <circle class="st560" cx="250.2" cy="235.2" r="1.8"/>
          <circle class="st561" cx="250.2" cy="235.2" r="1.6"/>
          <circle class="st133" cx="250.2" cy="235.2" r="1.5"/>
        </g>
      </g>
      <polygon class="st562" points="212.5,299.3 214.6,305.6 220.9,303.5      "/>
    </g>
    <g>
      <path class="st563" d="M224.9,226.3c-0.9,0.9-7.7-6.3-8.6-5.4c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8
        c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8
        c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8
        c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8
        c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8
        c-0.9,0.9,7.7,9.5,6.8,10.4c-0.9,0.9-9.5-7.7-10.3-6.8"/>
      <path class="st564" d="M181,256.2c-0.4,0.4,1.3,2.6,3.2,4.9c0,0,0,0,0,0c0.4,0.5,0.3,1.2-0.1,1.6l-2.3,2.1"/>
      <path class="st564" d="M181,256.2"/>
      <g>
        <g>
          <circle class="st2" cx="227.9" cy="219.1" r="9.1"/>
          <circle class="st2" cx="227.9" cy="219.1" r="9.1"/>
          <circle class="st2" cx="227.9" cy="219.1" r="9"/>
          <circle class="st4" cx="227.9" cy="219.1" r="9"/>
          <circle class="st4" cx="227.9" cy="219.1" r="8.9"/>
          <circle class="st5" cx="227.9" cy="219.1" r="8.9"/>
          <circle class="st5" cx="227.9" cy="219.1" r="8.8"/>
          <circle class="st5" cx="227.9" cy="219.1" r="8.8"/>
          <circle class="st6" cx="227.9" cy="219.1" r="8.7"/>
          <circle class="st6" cx="227.9" cy="219.1" r="8.7"/>
          <circle class="st7" cx="227.9" cy="219.1" r="8.7"/>
          <circle class="st7" cx="227.9" cy="219.1" r="8.6"/>
          <circle class="st7" cx="227.9" cy="219.1" r="8.6"/>
          <circle class="st8" cx="227.9" cy="219.1" r="8.5"/>
          <circle class="st8" cx="227.9" cy="219.1" r="8.5"/>
          <circle class="st9" cx="227.9" cy="219.1" r="8.4"/>
          <circle class="st9" cx="227.9" cy="219.1" r="8.4"/>
          <circle class="st9" cx="227.9" cy="219.1" r="8.3"/>
          <circle class="st11" cx="227.9" cy="219.1" r="8.3"/>
          <circle class="st11" cx="227.9" cy="219.1" r="8.2"/>
          <circle class="st12" cx="227.9" cy="219.1" r="8.2"/>
          <circle class="st12" cx="227.9" cy="219.1" r="8.1"/>
          <circle class="st12" cx="227.9" cy="219.1" r="8.1"/>
          <circle class="st13" cx="227.9" cy="219.1" r="8"/>
          <circle class="st13" cx="227.9" cy="219.1" r="8"/>
          <circle class="st14" cx="227.9" cy="219.1" r="7.9"/>
          <circle class="st14" cx="227.9" cy="219.1" r="7.9"/>
          <circle class="st14" cx="227.9" cy="219.1" r="7.8"/>
          <circle class="st16" cx="227.9" cy="219.1" r="7.8"/>
          <circle class="st16" cx="227.9" cy="219.1" r="7.8"/>
          <circle class="st17" cx="227.9" cy="219.1" r="7.7"/>
          <circle class="st17" cx="227.9" cy="219.1" r="7.7"/>
          <circle class="st17" cx="227.9" cy="219.1" r="7.6"/>
          <circle class="st19" cx="227.9" cy="219.1" r="7.6"/>
          <circle class="st19" cx="227.9" cy="219.1" r="7.5"/>
          <circle class="st20" cx="227.9" cy="219.1" r="7.5"/>
          <circle class="st20" cx="227.9" cy="219.1" r="7.4"/>
          <circle class="st21" cx="227.9" cy="219.1" r="7.4"/>
          <circle class="st22" cx="227.9" cy="219.1" r="7.3"/>
          <circle class="st22" cx="227.9" cy="219.1" r="7.3"/>
          <circle class="st23" cx="227.9" cy="219.1" r="7.2"/>
          <circle class="st23" cx="227.9" cy="219.1" r="7.2"/>
          <circle class="st25" cx="227.9" cy="219.1" r="7.1"/>
          <circle class="st25" cx="227.9" cy="219.1" r="7.1"/>
          <circle class="st25" cx="227.9" cy="219.1" r="7"/>
          <circle class="st565" cx="227.9" cy="219.1" r="7"/>
          <circle class="st27" cx="227.9" cy="219.1" r="7"/>
          <circle class="st28" cx="227.9" cy="219.1" r="6.9"/>
          <circle class="st28" cx="227.9" cy="219.1" r="6.9"/>
          <circle class="st28" cx="227.9" cy="219.1" r="6.8"/>
          <circle class="st566" cx="227.9" cy="219.1" r="6.8"/>
          <circle class="st30" cx="227.9" cy="219.1" r="6.7"/>
          <circle class="st567" cx="227.9" cy="219.1" r="6.7"/>
          <circle class="st567" cx="227.9" cy="219.1" r="6.6"/>
          <circle class="st567" cx="227.9" cy="219.1" r="6.6"/>
          <circle class="st568" cx="227.9" cy="219.1" r="6.5"/>
          <circle class="st32" cx="227.9" cy="219.1" r="6.5"/>
          <circle class="st569" cx="227.9" cy="219.1" r="6.4"/>
          <circle class="st569" cx="227.9" cy="219.1" r="6.4"/>
          <circle class="st570" cx="227.9" cy="219.1" r="6.3"/>
          <circle class="st570" cx="227.9" cy="219.1" r="6.3"/>
          <circle class="st571" cx="227.9" cy="219.1" r="6.2"/>
          <circle class="st35" cx="227.9" cy="219.1" r="6.2"/>
          <circle class="st35" cx="227.9" cy="219.1" r="6.1"/>
          <circle class="st572" cx="227.9" cy="219.1" r="6.1"/>
          <circle class="st572" cx="227.9" cy="219.1" r="6.1"/>
          <circle class="st573" cx="227.9" cy="219.1" r="6"/>
          <circle class="st38" cx="227.9" cy="219.1" r="6"/>
          <circle class="st574" cx="227.9" cy="219.1" r="5.9"/>
          <circle class="st574" cx="227.9" cy="219.1" r="5.9"/>
          <circle class="st574" cx="227.9" cy="219.1" r="5.8"/>
          <circle class="st575" cx="227.9" cy="219.1" r="5.8"/>
          <circle class="st575" cx="227.9" cy="219.1" r="5.7"/>
          <circle class="st576" cx="227.9" cy="219.1" r="5.7"/>
          <circle class="st577" cx="227.9" cy="219.1" r="5.6"/>
          <circle class="st578" cx="227.9" cy="219.1" r="5.6"/>
          <circle class="st579" cx="227.9" cy="219.1" r="5.5"/>
          <circle class="st580" cx="227.9" cy="219.1" r="5.5"/>
          <circle class="st581" cx="227.9" cy="219.1" r="5.4"/>
          <circle class="st582" cx="227.9" cy="219.1" r="5.4"/>
          <circle class="st583" cx="227.9" cy="219.1" r="5.3"/>
          <circle class="st584" cx="227.9" cy="219.1" r="5.3"/>
          <circle class="st585" cx="227.9" cy="219.1" r="5.3"/>
          <circle class="st586" cx="227.9" cy="219.1" r="5.2"/>
          <circle class="st587" cx="227.9" cy="219.1" r="5.2"/>
          <circle class="st588" cx="227.9" cy="219.1" r="5.1"/>
          <circle class="st589" cx="227.9" cy="219.1" r="5.1"/>
          <circle class="st590" cx="227.9" cy="219.1" r="5"/>
          <circle class="st591" cx="227.9" cy="219.1" r="5"/>
          <circle class="st592" cx="227.9" cy="219.1" r="4.9"/>
          <circle class="st593" cx="227.9" cy="219.1" r="4.9"/>
          <circle class="st594" cx="227.9" cy="219.1" r="4.8"/>
          <circle class="st595" cx="227.9" cy="219.1" r="4.8"/>
          <circle class="st596" cx="227.9" cy="219.1" r="4.7"/>
          <circle class="st597" cx="227.9" cy="219.1" r="4.7"/>
          <circle class="st598" cx="227.9" cy="219.1" r="4.6"/>
          <circle class="st599" cx="227.9" cy="219.1" r="4.6"/>
          <circle class="st600" cx="227.9" cy="219.1" r="4.5"/>
          <circle class="st601" cx="227.9" cy="219.1" r="4.5"/>
          <circle class="st602" cx="227.9" cy="219.1" r="4.4"/>
          <circle class="st603" cx="227.9" cy="219.1" r="4.4"/>
          <circle class="st604" cx="227.9" cy="219.1" r="4.4"/>
          <circle class="st605" cx="227.9" cy="219.1" r="4.3"/>
          <circle class="st606" cx="227.9" cy="219.1" r="4.3"/>
          <circle class="st607" cx="227.9" cy="219.1" r="4.2"/>
          <circle class="st608" cx="227.9" cy="219.1" r="4.2"/>
          <circle class="st609" cx="227.9" cy="219.1" r="4.1"/>
          <circle class="st610" cx="227.9" cy="219.1" r="4.1"/>
          <circle class="st611" cx="227.9" cy="219.1" r="4"/>
          <circle class="st612" cx="227.9" cy="219.1" r="4"/>
          <circle class="st613" cx="227.9" cy="219.1" r="3.9"/>
          <circle class="st614" cx="227.9" cy="219.1" r="3.9"/>
          <circle class="st615" cx="227.9" cy="219.1" r="3.8"/>
          <circle class="st616" cx="227.9" cy="219.1" r="3.8"/>
          <circle class="st617" cx="227.9" cy="219.1" r="3.7"/>
          <circle class="st618" cx="227.9" cy="219.1" r="3.7"/>
          <circle class="st619" cx="227.9" cy="219.1" r="3.6"/>
          <circle class="st620" cx="227.9" cy="219.1" r="3.6"/>
          <circle class="st621" cx="227.9" cy="219.1" r="3.5"/>
          <circle class="st622" cx="227.9" cy="219.1" r="3.5"/>
          <circle class="st623" cx="227.9" cy="219.1" r="3.5"/>
          <circle class="st624" cx="227.9" cy="219.1" r="3.4"/>
          <circle class="st625" cx="227.9" cy="219.1" r="3.4"/>
          <circle class="st626" cx="227.9" cy="219.1" r="3.3"/>
          <circle class="st627" cx="227.9" cy="219.1" r="3.3"/>
          <circle class="st628" cx="227.9" cy="219.1" r="3.2"/>
          <circle class="st629" cx="227.9" cy="219.1" r="3.2"/>
          <circle class="st630" cx="227.9" cy="219.1" r="3.1"/>
          <circle class="st631" cx="227.9" cy="219.1" r="3.1"/>
          <circle class="st632" cx="227.9" cy="219.1" r="3"/>
          <circle class="st633" cx="227.9" cy="219.1" r="3"/>
          <circle class="st634" cx="227.9" cy="219.1" r="2.9"/>
          <circle class="st635" cx="227.9" cy="219.1" r="2.9"/>
          <circle class="st636" cx="227.9" cy="219.1" r="2.8"/>
          <circle class="st637" cx="227.9" cy="219.1" r="2.8"/>
          <circle class="st638" cx="227.9" cy="219.1" r="2.7"/>
          <circle class="st639" cx="227.9" cy="219.1" r="2.7"/>
          <circle class="st640" cx="227.9" cy="219.1" r="2.7"/>
          <circle class="st641" cx="227.9" cy="219.1" r="2.6"/>
          <circle class="st642" cx="227.9" cy="219.1" r="2.6"/>
          <circle class="st643" cx="227.9" cy="219.1" r="2.5"/>
          <circle class="st644" cx="227.9" cy="219.1" r="2.5"/>
          <circle class="st645" cx="227.9" cy="219.1" r="2.4"/>
          <circle class="st646" cx="227.9" cy="219.1" r="2.4"/>
          <circle class="st647" cx="227.9" cy="219.1" r="2.3"/>
          <circle class="st648" cx="227.9" cy="219.1" r="2.3"/>
          <circle class="st649" cx="227.9" cy="219.1" r="2.2"/>
          <circle class="st650" cx="227.9" cy="219.1" r="2.2"/>
          <circle class="st651" cx="227.9" cy="219.1" r="2.1"/>
          <circle class="st652" cx="227.9" cy="219.1" r="2.1"/>
          <circle class="st653" cx="227.9" cy="219.1" r="2"/>
          <circle class="st654" cx="227.9" cy="219.1" r="2"/>
          <circle class="st655" cx="227.9" cy="219.1" r="1.9"/>
          <circle class="st656" cx="227.9" cy="219.1" r="1.9"/>
          <circle class="st657" cx="227.9" cy="219.1" r="1.8"/>
          <circle class="st658" cx="227.9" cy="219.1" r="1.8"/>
          <circle class="st659" cx="227.9" cy="219.1" r="1.8"/>
          <circle class="st660" cx="227.9" cy="219.1" r="1.7"/>
          <circle class="st661" cx="227.9" cy="219.1" r="1.7"/>
          <circle class="st662" cx="227.9" cy="219.1" r="1.6"/>
          <circle class="st663" cx="227.9" cy="219.1" r="1.6"/>
          <circle class="st664" cx="227.9" cy="219.1" r="1.5"/>
        </g>
      </g>
      <polygon class="st665" points="179.6,261.2 179.2,267.8 185.8,268.2      "/>
    </g>
    <g>
      <path class="st666" d="M405.3,281.9c-6.2-6.3-14.9,2.3-21.1-4c-6.2-6.3,2.4-14.8-3.9-21.1c-6.2-6.3-14.9,2.3-21.1-4
        c-6.2-6.3,2.4-14.8-3.9-21.1"/>
      <g>
        <g>
          <circle class="st260" cx="345" cy="218.8" r="18.4"/>
          <circle class="st261" cx="345" cy="218.8" r="18.3"/>
          <circle class="st667" cx="345" cy="218.8" r="18.2"/>
          <circle class="st263" cx="345" cy="218.8" r="18.1"/>
          <circle class="st264" cx="345" cy="218.8" r="18"/>
          <circle class="st668" cx="345" cy="218.8" r="17.9"/>
          <circle class="st266" cx="345" cy="218.8" r="17.8"/>
          <circle class="st669" cx="345" cy="218.8" r="17.7"/>
          <circle class="st670" cx="345" cy="218.8" r="17.6"/>
          <circle class="st269" cx="345" cy="218.8" r="17.5"/>
          <circle class="st671" cx="345" cy="218.8" r="17.4"/>
          <circle class="st672" cx="345" cy="218.8" r="17.3"/>
          <circle class="st673" cx="345" cy="218.8" r="17.2"/>
          <circle class="st674" cx="345" cy="218.8" r="17.1"/>
          <circle class="st675" cx="345" cy="218.8" r="17"/>
          <circle class="st676" cx="345" cy="218.8" r="16.9"/>
          <circle class="st677" cx="345" cy="218.8" r="16.8"/>
          <circle class="st678" cx="345" cy="218.8" r="16.7"/>
          <circle class="st679" cx="345" cy="218.8" r="16.6"/>
          <circle class="st680" cx="345" cy="218.8" r="16.5"/>
          <circle class="st681" cx="345" cy="218.8" r="16.4"/>
          <circle class="st682" cx="345" cy="218.8" r="16.3"/>
          <circle class="st683" cx="345" cy="218.8" r="16.2"/>
          <circle class="st684" cx="345" cy="218.8" r="16.1"/>
          <circle class="st685" cx="345" cy="218.8" r="16"/>
          <circle class="st686" cx="345" cy="218.8" r="15.9"/>
          <circle class="st687" cx="345" cy="218.8" r="15.8"/>
          <circle class="st688" cx="345" cy="218.8" r="15.7"/>
          <circle class="st689" cx="345" cy="218.8" r="15.6"/>
          <circle class="st690" cx="345" cy="218.8" r="15.5"/>
          <circle class="st691" cx="345" cy="218.8" r="15.4"/>
          <circle class="st692" cx="345" cy="218.8" r="15.3"/>
          <circle class="st693" cx="345" cy="218.8" r="15.2"/>
          <circle class="st694" cx="345" cy="218.8" r="15.1"/>
          <circle class="st695" cx="345" cy="218.8" r="15"/>
          <circle class="st696" cx="345" cy="218.8" r="14.9"/>
          <circle class="st697" cx="345" cy="218.8" r="14.8"/>
          <circle class="st698" cx="345" cy="218.8" r="14.7"/>
          <circle class="st699" cx="345" cy="218.8" r="14.6"/>
          <circle class="st700" cx="345" cy="218.8" r="14.5"/>
          <circle class="st701" cx="345" cy="218.8" r="14.5"/>
          <circle class="st702" cx="345" cy="218.8" r="14.4"/>
          <circle class="st703" cx="345" cy="218.8" r="14.3"/>
          <circle class="st704" cx="345" cy="218.8" r="14.2"/>
          <circle class="st705" cx="345" cy="218.8" r="14.1"/>
          <circle class="st706" cx="345" cy="218.8" r="14"/>
          <circle class="st707" cx="345" cy="218.8" r="13.9"/>
          <circle class="st708" cx="345" cy="218.8" r="13.8"/>
          <circle class="st709" cx="345" cy="218.8" r="13.7"/>
          <circle class="st710" cx="345" cy="218.8" r="13.6"/>
          <circle class="st711" cx="345" cy="218.8" r="13.5"/>
          <circle class="st712" cx="345" cy="218.8" r="13.4"/>
          <circle class="st713" cx="345" cy="218.8" r="13.3"/>
          <circle class="st714" cx="345" cy="218.8" r="13.2"/>
          <circle class="st715" cx="345" cy="218.8" r="13.1"/>
          <circle class="st716" cx="345" cy="218.8" r="13"/>
          <circle class="st717" cx="345" cy="218.8" r="12.9"/>
          <circle class="st718" cx="345" cy="218.8" r="12.8"/>
          <circle class="st719" cx="345" cy="218.8" r="12.7"/>
          <circle class="st720" cx="345" cy="218.8" r="12.6"/>
          <circle class="st721" cx="345" cy="218.8" r="12.5"/>
          <circle class="st722" cx="345" cy="218.8" r="12.4"/>
          <circle class="st723" cx="345" cy="218.8" r="12.3"/>
          <circle class="st724" cx="345" cy="218.8" r="12.2"/>
          <circle class="st725" cx="345" cy="218.8" r="12.1"/>
          <circle class="st726" cx="345" cy="218.8" r="12"/>
          <circle class="st727" cx="345" cy="218.8" r="11.9"/>
          <circle class="st728" cx="345" cy="218.8" r="11.8"/>
          <circle class="st729" cx="345" cy="218.8" r="11.7"/>
          <circle class="st730" cx="345" cy="218.8" r="11.6"/>
          <circle class="st731" cx="345" cy="218.8" r="11.5"/>
          <circle class="st732" cx="345" cy="218.8" r="11.4"/>
          <circle class="st733" cx="345" cy="218.8" r="11.3"/>
          <circle class="st734" cx="345" cy="218.8" r="11.2"/>
          <circle class="st735" cx="345" cy="218.8" r="11.1"/>
          <circle class="st736" cx="345" cy="218.8" r="11"/>
          <circle class="st737" cx="345" cy="218.8" r="10.9"/>
          <circle class="st738" cx="345" cy="218.8" r="10.8"/>
          <circle class="st739" cx="345" cy="218.8" r="10.7"/>
          <circle class="st740" cx="345" cy="218.8" r="10.6"/>
          <circle class="st741" cx="345" cy="218.8" r="10.5"/>
          <circle class="st742" cx="345" cy="218.8" r="10.4"/>
          <circle class="st743" cx="345" cy="218.8" r="10.3"/>
          <circle class="st744" cx="345" cy="218.8" r="10.2"/>
          <circle class="st745" cx="345" cy="218.8" r="10.1"/>
          <circle class="st746" cx="345" cy="218.8" r="10"/>
          <circle class="st747" cx="345" cy="218.8" r="9.9"/>
          <circle class="st748" cx="345" cy="218.8" r="9.8"/>
          <circle class="st749" cx="345" cy="218.8" r="9.8"/>
          <circle class="st750" cx="345" cy="218.8" r="9.7"/>
          <circle class="st751" cx="345" cy="218.8" r="9.6"/>
          <circle class="st752" cx="345" cy="218.8" r="9.5"/>
          <circle class="st753" cx="345" cy="218.8" r="9.4"/>
          <circle class="st754" cx="345" cy="218.8" r="9.3"/>
          <circle class="st755" cx="345" cy="218.8" r="9.2"/>
          <circle class="st756" cx="345" cy="218.8" r="9.1"/>
          <circle class="st757" cx="345" cy="218.8" r="9"/>
          <circle class="st757" cx="345" cy="218.8" r="8.9"/>
          <circle class="st758" cx="345" cy="218.8" r="8.8"/>
          <circle class="st759" cx="345" cy="218.8" r="8.7"/>
          <circle class="st760" cx="345" cy="218.8" r="8.6"/>
          <circle class="st761" cx="345" cy="218.8" r="8.5"/>
          <circle class="st762" cx="345" cy="218.8" r="8.4"/>
          <circle class="st763" cx="345" cy="218.8" r="8.3"/>
          <circle class="st764" cx="345" cy="218.8" r="8.2"/>
          <circle class="st765" cx="345" cy="218.8" r="8.1"/>
          <circle class="st766" cx="345" cy="218.8" r="8"/>
          <circle class="st767" cx="345" cy="218.8" r="7.9"/>
          <circle class="st768" cx="345" cy="218.8" r="7.8"/>
          <circle class="st769" cx="345" cy="218.8" r="7.7"/>
          <circle class="st770" cx="345" cy="218.8" r="7.6"/>
          <circle class="st771" cx="345" cy="218.8" r="7.5"/>
          <circle class="st772" cx="345" cy="218.8" r="7.4"/>
          <circle class="st773" cx="345" cy="218.8" r="7.3"/>
          <circle class="st774" cx="345" cy="218.8" r="7.2"/>
          <circle class="st775" cx="345" cy="218.8" r="7.1"/>
          <circle class="st776" cx="345" cy="218.8" r="7"/>
          <circle class="st777" cx="345" cy="218.8" r="6.9"/>
          <circle class="st778" cx="345" cy="218.8" r="6.8"/>
          <circle class="st779" cx="345" cy="218.8" r="6.7"/>
          <circle class="st780" cx="345" cy="218.8" r="6.6"/>
          <circle class="st781" cx="345" cy="218.8" r="6.5"/>
          <circle class="st781" cx="345" cy="218.8" r="6.4"/>
          <circle class="st782" cx="345" cy="218.8" r="6.3"/>
          <circle class="st783" cx="345" cy="218.8" r="6.2"/>
          <circle class="st784" cx="345" cy="218.8" r="6.1"/>
          <circle class="st785" cx="345" cy="218.8" r="6"/>
          <circle class="st786" cx="345" cy="218.8" r="5.9"/>
          <circle class="st787" cx="345" cy="218.8" r="5.8"/>
          <circle class="st787" cx="345" cy="218.8" r="5.7"/>
          <circle class="st788" cx="345" cy="218.8" r="5.6"/>
          <circle class="st789" cx="345" cy="218.8" r="5.5"/>
          <circle class="st790" cx="345" cy="218.8" r="5.4"/>
          <circle class="st791" cx="345" cy="218.8" r="5.3"/>
          <circle class="st792" cx="345" cy="218.8" r="5.2"/>
          <circle class="st792" cx="345" cy="218.8" r="5.1"/>
          <circle class="st793" cx="345" cy="218.8" r="5"/>
          <circle class="st794" cx="345" cy="218.8" r="5"/>
          <circle class="st795" cx="345" cy="218.8" r="4.9"/>
          <circle class="st796" cx="345" cy="218.8" r="4.8"/>
          <circle class="st797" cx="345" cy="218.8" r="4.7"/>
          <circle class="st798" cx="345" cy="218.8" r="4.6"/>
          <circle class="st799" cx="345" cy="218.8" r="4.5"/>
          <circle class="st800" cx="345" cy="218.8" r="4.4"/>
          <circle class="st801" cx="345" cy="218.8" r="4.3"/>
          <circle class="st802" cx="345" cy="218.8" r="4.2"/>
          <circle class="st802" cx="345" cy="218.8" r="4.1"/>
          <circle class="st803" cx="345" cy="218.8" r="4"/>
          <circle class="st804" cx="345" cy="218.8" r="3.9"/>
          <circle class="st805" cx="345" cy="218.8" r="3.8"/>
          <circle class="st806" cx="345" cy="218.8" r="3.7"/>
          <circle class="st806" cx="345" cy="218.8" r="3.6"/>
          <circle class="st807" cx="345" cy="218.8" r="3.5"/>
          <circle class="st808" cx="345" cy="218.8" r="3.4"/>
          <circle class="st809" cx="345" cy="218.8" r="3.3"/>
          <circle class="st810" cx="345" cy="218.8" r="3.2"/>
          <circle class="st810" cx="345" cy="218.8" r="3.1"/>
          <circle class="st811" cx="345" cy="218.8" r="3"/>
          <circle class="st812" cx="345" cy="218.8" r="2.9"/>
        </g>
      </g>
      <polygon class="st813" points="402.3,285.5 408.9,284.9 408.3,278.3      "/>
    </g>
  </g>
</g>

<polygon class="st1 content-2-triangle" points="194,169.9 194,159.9 199,164.9 " />

<line class="st814" x1="35.8" y1="33.9" x2="35.8" y2="0"/>
<g>
  <defs>
    <ellipse id="SVGID_00000044158266065655253410000006251382995122993795_" cx="281.3" cy="185.7" rx="48.3" ry="40.7"/>
  </defs>
  <clipPath id="SVGID_00000024684344544896281190000014246610444625926054_">
    <use xlink:href="#SVGID_00000044158266065655253410000006251382995122993795_"  style="overflow:visible;"/>
  </clipPath>
  <g style="clip-path:url(#SVGID_00000024684344544896281190000014246610444625926054_);">
    
      <image style="overflow:visible;" width="347" height="356" xlink:href="https://v.postimees.ee/graafikud/2023/keemiapreemia-2/lamp.png"  transform="matrix(0.24 0 0 0.24 240.5754 141.3967)">
    </image>
  </g>
</g>
</svg>


      <!-- <div style="top: 80%; left: 0">
        <strong> Atosekund </strong>
        <small> 1/1 000 000 000 000 000 000<br />sekundit </small>
      </div> -->
    </main>

    <footer>
      Allikas: Johan Jarnestad/Rootsi Kuninglik Teaduste Akadeemia
    </footer>
  </div>
</template>

<style>
.device-phone #keemiapreemia-2 {
  margin-left: calc(var(--root-padding) * -1);
  margin-right: calc(var(--root-padding) * -1);
}
</style>

<style scoped>
.chart {
  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);

  font-size: 16px;
  line-height: 1;
  word-spacing: 0;

  width: 100%;
  display: flex;
  flex-direction: column;

  background-color: var(--light);
  border-radius: 3px;

  box-sizing: border-box;
  padding: 2em;

  overflow: hidden;

  --section-background-color: #e4e9ee;

  --container-width: v-bind(containerWidth + "px");

/*  max-width: 615px;*/
}

.small.chart,
.device-phone .chart {
  padding: var(--root-padding);
  border-radius: 0;

  font-size: 13px;
}

.dark-theme .chart {
  --section-background-color: var(--gray-darken-3);
}

.chart > strong {
  font-size: 2em;
  line-height: 1.15;
  text-wrap: balance;

  margin-bottom: 0.25em;
}

.chart.small > strong {
  font-size: 1.55em;
}

.lead,
footer {
  font-size: 1em;
  font-weight: 300;
  line-height: 1.33;
}

.dark-theme .lead,
.dark-theme footer {
  font-weight: 400;
}

footer {
  font-size: 0.8em;
  margin-top: 1em;
  text-wrap: balance;
  text-align: right;
}

main {
  margin-top: 2em;

  display: flex;

  position: relative;
}

main > svg {
  width: 100%;
}

.dark-theme main > svg {
  filter: invert(1) hue-rotate(180deg);
}

svg text {
  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

main > div {
  position: absolute;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  font-size: clamp(3px, calc(0.0223 * var(--container-width)), 99px);
  font-weight: 700;
  line-height: 1.1;
  text-align: left;
}

main > div.content-2 {
  width: 42%; 
  top: 40%; 

  font-size: clamp(3px, calc(0.033 * var(--container-width)), 99px);
  color: var(--gray);
}

.st0{fill:none;stroke:#1C1B18;stroke-miterlimit:10;}
  
  .st1{fill:#1C1B18;}

  .st2{fill:#0097DC;}
  .st3{fill:#0098DC;}
  .st4{fill:#0098DD;}
  .st5{fill:#0099DD;}
  .st6{fill:#009ADE;}
  .st7{fill:#009BDE;}
  .st8{fill:#009CDF;}
  .st9{fill:#009DDF;}
  .st10{fill:#009DE0;}
  .st11{fill:#009EE0;}
  .st12{fill:#009FE0;}
  .st13{fill:#00A0E1;}
  .st14{fill:#00A1E1;}
  .st15{fill:#00A1E2;}
  .st16{fill:#00A2E2;}
  .st17{fill:#00A3E2;}
  .st18{fill:#00A3E3;}
  .st19{fill:#00A4E3;}
  .st20{fill:#00A5E3;}
  .st21{fill:#00A5E4;}
  .st22{fill:#00A6E4;}
  .st23{fill:#00A7E4;}
  .st24{fill:#00A7E5;}
  .st25{fill:#00A8E5;}
  .st26{fill:#00A8E6;}
  .st27{fill:#00A9E6;}
  .st28{fill:#00AAE6;}
  .st29{fill:#00AAE7;}
  .st30{fill:#00ABE7;}
  .st31{fill:#00ACE8;}
  .st32{fill:#00ADE8;}
  .st33{fill:#00AEE9;}
  .st34{fill:#00AFE9;}
  .st35{fill:#00B0E9;}
  .st36{fill:#00B0EA;}
  .st37{fill:#00B1EA;}
  .st38{fill:#00B2EA;}
  .st39{fill:#00B2EB;}
  .st40{fill:#00B3EB;}
  .st41{fill:#00B4EB;}
  .st42{fill:#00B5EC;}
  .st43{fill:#00B6EC;}
  .st44{fill:#00B7EC;}
  .st45{fill:#00B7ED;}
  .st46{fill:#00B8ED;}
  .st47{fill:#0AB9ED;}
  .st48{fill:#13B9EE;}
  .st49{fill:#1ABAEE;}
  .st50{fill:#1FBAEE;}
  .st51{fill:#24BBEE;}
  .st52{fill:#28BBEE;}
  .st53{fill:#2CBCEF;}
  .st54{fill:#30BCEF;}
  .st55{fill:#33BDEF;}
  .st56{fill:#36BDEF;}
  .st57{fill:#39BEEF;}
  .st58{fill:#3CBEEF;}
  .st59{fill:#3FBFF0;}
  .st60{fill:#41BFF0;}
  .st61{fill:#44C0F0;}
  .st62{fill:#46C0F0;}
  .st63{fill:#49C1F0;}
  .st64{fill:#4BC1F0;}
  .st65{fill:#4DC2F1;}
  .st66{fill:#4FC2F1;}
  .st67{fill:#51C3F1;}
  .st68{fill:#53C3F1;}
  .st69{fill:#6AB52C;}
  .st70{fill:#6BB52B;}
  .st71{fill:#6DB52B;}
  .st72{fill:#6EB62A;}
  .st73{fill:#6FB62A;}
  .st74{fill:#71B72A;}
  .st75{fill:#72B729;}
  .st76{fill:#73B729;}
  .st77{fill:#75B829;}
  .st78{fill:#76B828;}
  .st79{fill:#77B828;}
  .st80{fill:#78B928;}
  .st81{fill:#7AB927;}
  .st82{fill:#7BBA27;}
  .st83{fill:#7CBA27;}
  .st84{fill:#7DBA26;}
  .st85{fill:#7EBB26;}
  .st86{fill:#80BB25;}
  .st87{fill:#81BB25;}
  .st88{fill:#82BC25;}
  .st89{fill:#83BC24;}
  .st90{fill:#84BC24;}
  .st91{fill:#86BD24;}
  .st92{fill:#87BD23;}
  .st93{fill:#88BD23;}
  .st94{fill:#89BE23;}
  .st95{fill:#8ABE22;}
  .st96{fill:#8BBE22;}
  .st97{fill:#8DBF21;}
  .st98{fill:#8EBF21;}
  .st99{fill:#8FBF21;}
  .st100{fill:#90C020;}
  .st101{fill:#91C020;}
  .st102{fill:#92C01F;}
  .st103{fill:#93C11F;}
  .st104{fill:#95C11E;}
  .st105{fill:#96C21E;}
  .st106{fill:#97C21D;}
  .st107{fill:#98C21C;}
  .st108{fill:#99C31C;}
  .st109{fill:#9AC31B;}
  .st110{fill:#9BC31A;}
  .st111{fill:#9CC419;}
  .st112{fill:#9DC419;}
  .st113{fill:#9EC418;}
  .st114{fill:#9FC517;}
  .st115{fill:#A0C516;}
  .st116{fill:#A1C515;}
  .st117{fill:#A2C614;}
  .st118{fill:#A3C613;}
  .st119{fill:#A4C712;}
  .st120{fill:#A5C711;}
  .st121{fill:#A6C710;}
  .st122{fill:#A7C80E;}
  .st123{fill:#A8C80D;}
  .st124{fill:#A9C80C;}
  .st125{fill:#AAC90A;}
  .st126{fill:#ABC909;}
  .st127{fill:#ACC907;}
  .st128{fill:#ADCA05;}
  .st129{fill:#AECA04;}
  .st130{fill:#AFCA02;}
  .st131{fill:#B0CB01;}
  .st132{fill:#B1CB00;}
  .st133{fill:#B2CB00;}
  .st134{fill:#B3CC00;}
  .st135{fill:#B4CC00;}
  .st136{fill:#B5CD00;}
  .st137{fill:#B6CD00;}
  .st138{fill:#B7CD00;}
  .st139{fill:#B8CE00;}
  .st140{fill:#B9CE00;}
  .st141{fill:#BACE00;}
  .st142{fill:#BBCF00;}
  .st143{fill:#BCCF00;}
  .st144{fill:#BDCF00;}
  .st145{fill:#BED000;}
  .st146{fill:#BFD000;}
  .st147{fill:#C0D000;}
  .st148{fill:#C1D100;}
  .st149{fill:#C2D100;}
  .st150{fill:#C3D100;}
  .st151{fill:#C4D200;}
  .st152{fill:#C5D200;}
  .st153{fill:#C6D200;}
  .st154{fill:#C7D300;}
  .st155{fill:#C8D300;}
  .st156{fill:#C9D400;}
  .st157{fill:#CAD400;}
  .st158{fill:#CBD400;}
  .st159{fill:#CBD500;}
  .st160{fill:#CCD500;}
  .st161{fill:#CDD500;}
  .st162{fill:#CED600;}
  .st163{fill:#CFD600;}
  .st164{fill:#DFDD00;}
  .st165{fill:#E0DD00;}
  .st166{fill:#E1DE00;}
  .st167{fill:#E2DE00;}
  .st168{fill:#E3DF00;}
  .st169{fill:#E4DF00;}
  .st170{fill:#E5DF00;}
  .st171{fill:#E6E000;}
  .st172{fill:#E7E000;}
  .st173{fill:#E8E000;}
  .st174{fill:#E8E100;}
  .st175{fill:#E9E100;}
  .st176{fill:#EAE100;}
  .st177{fill:#EBE100;}
  .st178{fill:#ECE200;}
  .st179{fill:#EDE200;}
  .st180{fill:#EEE300;}
  .st181{fill:#EFE300;}
  .st182{fill:#F0E300;}
  .st183{fill:#F1E400;}
  .st184{fill:#F2E400;}
  .st185{fill:#F3E400;}
  .st186{fill:#F3E500;}
  .st187{fill:#F4E500;}
  .st188{fill:#F5E500;}
  .st189{fill:#F6E600;}
  .st190{fill:#F7E600;}
  .st191{fill:#F8E700;}
  .st192{fill:#F9E700;}
  .st193{fill:#FAE700;}
  .st194{fill:#FAE800;}
  .st195{fill:#FBE800;}
  .st196{fill:#FCE800;}
  .st197{fill:#FDE900;}
  .st198{fill:#FEE900;}
  .st199{fill:#FFEA00;}
  .st200{fill:#FFEB00;}
  .st201{fill:#FFEC00;}
  .st202{fill:#FFED00;}
  .st203{fill:#FBBC47;}
  .st204{fill:#FBBD47;}
  .st205{fill:#FCBE47;}
  .st206{fill:#FCBF47;}
  .st207{fill:#FCC047;}
  .st208{fill:#FCC147;}
  .st209{fill:#FCC247;}
  .st210{fill:#FCC347;}
  .st211{fill:#FDC347;}
  .st212{fill:#FDC447;}
  .st213{fill:#FDC547;}
  .st214{fill:#FDC647;}
  .st215{fill:#FDC747;}
  .st216{fill:#FDC848;}
  .st217{fill:#FDC948;}
  .st218{fill:#FEC948;}
  .st219{fill:#FECA48;}
  .st220{fill:#FECB48;}
  .st221{fill:#FECC48;}
  .st222{fill:#FECD48;}
  .st223{fill:#FECE48;}
  .st224{fill:#FECF48;}
  .st225{fill:#FFCF48;}
  .st226{fill:#FFD048;}
  .st227{fill:#FFD148;}
  .st228{fill:#FFD248;}
  .st229{fill:#FFD348;}
  .st230{fill:#FFD448;}
  .st231{fill:#FFD548;}
  .st232{fill:#FFD648;}
  .st233{fill:#FFD748;}
  .st234{fill:#FFD848;}
  .st235{fill:#FFD948;}
  .st236{fill:#FFDA48;}
  .st237{fill:#FFDB48;}
  .st238{fill:#FFDC47;}
  .st239{fill:#FFDD47;}
  .st240{fill:#FFDE47;}
  .st241{fill:#FFDF47;}
  .st242{fill:#FFE047;}
  .st243{fill:#FFE147;}
  .st244{fill:#FFE247;}
  .st245{fill:#FFE347;}
  .st246{fill:#FFE447;}
  .st247{fill:#FFE448;}
  .st248{fill:#FFE548;}
  .st249{fill:#FFE648;}
  .st250{fill:#FFE748;}
  .st251{fill:#FFE848;}
  .st252{fill:#FFE948;}
  .st253{fill:#FFEA48;}
  .st254{fill:#FFEB48;}
  .st255{fill:#FFEC48;}
  .st256{fill:#FFED48;}
  .st257{fill:#FFEE48;}
  .st258{fill:#FFEF48;}
  .st259{fill:#FFF048;}
  .st260{fill:#E30311;}
  .st261{fill:#E30711;}
  .st262{fill:#E30B12;}
  .st263{fill:#E30E12;}
  .st264{fill:#E31112;}
  .st265{fill:#E41413;}
  .st266{fill:#E41613;}
  .st267{fill:#E41814;}
  .st268{fill:#E41A14;}
  .st269{fill:#E41C14;}
  .st270{fill:#E41E15;}
  .st271{fill:#E41F15;}
  .st272{fill:#E42116;}
  .st273{fill:#E42216;}
  .st274{fill:#E52416;}
  .st275{fill:#E52517;}
  .st276{fill:#E52717;}
  .st277{fill:#E52818;}
  .st278{fill:#E52918;}
  .st279{fill:#E52B18;}
  .st280{fill:#E52C19;}
  .st281{fill:#E52D19;}
  .st282{fill:#E52E19;}
  .st283{fill:#E62F1A;}
  .st284{fill:#E6301A;}
  .st285{fill:#E6321A;}
  .st286{fill:#E6331B;}
  .st287{fill:#E6341B;}
  .st288{fill:#E6351C;}
  .st289{fill:#E6361C;}
  .st290{fill:#E7381D;}
  .st291{fill:#E7391D;}
  .st292{fill:#E73A1D;}
  .st293{fill:#E73B1E;}
  .st294{fill:#E73C1E;}
  .st295{fill:#E73D1F;}
  .st296{fill:#E73E1F;}
  .st297{fill:#E83F20;}
  .st298{fill:#E84120;}
  .st299{fill:#E84221;}
  .st300{fill:#E84321;}
  .st301{fill:#E84421;}
  .st302{fill:#E84522;}
  .st303{fill:#E94622;}
  .st304{fill:#E94723;}
  .st305{fill:#E94823;}
  .st306{fill:#E94924;}
  .st307{fill:#E94A24;}
  .st308{fill:#E94B25;}
  .st309{fill:#EA4C26;}
  .st310{fill:#EA4D27;}
  .st311{fill:#EA4E27;}
  .st312{fill:#EA4F28;}
  .st313{fill:#EA5128;}
  .st314{fill:#EA5229;}
  .st315{fill:#EA5329;}
  .st316{fill:#EA542A;}
  .st317{fill:#EA552B;}
  .st318{fill:#EB562B;}
  .st319{fill:#EB572C;}
  .st320{fill:#EB582C;}
  .st321{fill:#EB592D;}
  .st322{fill:#EB5A2D;}
  .st323{fill:#EB5B2E;}
  .st324{fill:#EB5C2F;}
  .st325{fill:#EB5D2F;}
  .st326{fill:#EB5E30;}
  .st327{fill:#EC5F30;}
  .st328{fill:#EC6031;}
  .st329{fill:#EC6131;}
  .st330{fill:#EC6232;}
  .st331{fill:#EC6333;}
  .st332{fill:#EC6433;}
  .st333{fill:#EC6534;}
  .st334{fill:#EC6634;}
  .st335{fill:#ED6735;}
  .st336{fill:#ED6835;}
  .st337{fill:#ED6936;}
  .st338{fill:#ED6A36;}
  .st339{fill:#ED6B37;}
  .st340{fill:#ED6C37;}
  .st341{fill:#ED6D38;}
  .st342{fill:#EE6E39;}
  .st343{fill:#EE6F39;}
  .st344{fill:#EE703A;}
  .st345{fill:#EE713A;}
  .st346{fill:#EE723B;}
  .st347{fill:#EE733C;}
  .st348{fill:#EE743C;}
  .st349{fill:#EF753D;}
  .st350{fill:#EF763D;}
  .st351{fill:#EF773E;}
  .st352{fill:#EF783E;}
  .st353{fill:#EF793F;}
  .st354{fill:#EF7A40;}
  .st355{fill:#EF7B40;}
  .st356{fill:#EF7C41;}
  .st357{fill:#F07D42;}
  .st358{fill:#F07E42;}
  .st359{fill:#F07F43;}
  .st360{fill:#F08043;}
  .st361{fill:#F08144;}
  .st362{fill:#F08245;}
  .st363{fill:#F08346;}
  .st364{fill:#F18446;}
  .st365{fill:#F18547;}
  .st366{fill:#F18648;}
  .st367{fill:#F18748;}
  .st368{fill:#F18849;}
  .st369{fill:#F18949;}
  .st370{fill:#F1894A;}
  .st371{fill:#F18A4B;}
  .st372{fill:#F28B4B;}
  .st373{fill:#F28C4C;}
  .st374{fill:#F28D4D;}
  .st375{fill:#F28E4D;}
  .st376{fill:#F28F4E;}
  .st377{fill:#F2904F;}
  .st378{fill:#F29150;}
  .st379{fill:#F39251;}
  .st380{fill:#F39352;}
  .st381{fill:#F39452;}
  .st382{fill:#F39553;}
  .st383{fill:#F39654;}
  .st384{fill:#F39754;}
  .st385{fill:#F39855;}
  .st386{fill:#F49856;}
  
    .st387{clip-path:url(#SVGID_00000078736576205323197320000006251321365305834887_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;}
  
    .st388{clip-path:url(#SVGID_00000025421246935556611310000005483103360943037100_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;}
  
    .st389{clip-path:url(#SVGID_00000043457948499958356240000007858871576084699826_);fill:none;stroke:#1C1B18;stroke-width:0.997;stroke-miterlimit:10;}
  
    .st390{clip-path:url(#SVGID_00000178924902465511177500000000891860569833608353_);fill:none;stroke:#1C1B18;stroke-miterlimit:10;}
  
    .st391{clip-path:url(#SVGID_00000010279564475822781280000000326963034240865183_);fill:none;stroke:#1C1B18;stroke-width:0.9958;stroke-miterlimit:10;}
  .st392{fill:none;stroke:#9D9D9D;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:2,2;}
  .st393{fill:none;stroke:#FFCF43;stroke-width:1.0077;stroke-miterlimit:10;}
  .st394{fill:#FBBD48;}
  .st395{fill:#FBBE49;}
  .st396{fill:#FCBF49;}
  .st397{fill:#FCBF4A;}
  .st398{fill:#FCC04B;}
  .st399{fill:#FCC14B;}
  .st400{fill:#FCC24C;}
  .st401{fill:#FCC24D;}
  .st402{fill:#FCC34D;}
  .st403{fill:#FCC44E;}
  .st404{fill:#FDC44F;}
  .st405{fill:#FDC54F;}
  .st406{fill:#FDC650;}
  .st407{fill:#FDC751;}
  .st408{fill:#FDC852;}
  .st409{fill:#FDC953;}
  .st410{fill:#FDC954;}
  .st411{fill:#FECA54;}
  .st412{fill:#FECB55;}
  .st413{fill:#FECC56;}
  .st414{fill:#FECD57;}
  .st415{fill:#FECE58;}
  .st416{fill:#FECF58;}
  .st417{fill:#FECF59;}
  .st418{fill:#FFD05A;}
  .st419{fill:#FFD15A;}
  .st420{fill:#FFD15B;}
  .st421{fill:#FFD25C;}
  .st422{fill:#FFD35C;}
  .st423{fill:#FFD45D;}
  .st424{fill:#FFD45E;}
  .st425{fill:#FFD55E;}
  .st426{fill:#FFD65F;}
  .st427{fill:#FFD660;}
  .st428{fill:#FFD760;}
  .st429{fill:#FFD861;}
  .st430{fill:#FFD862;}
  .st431{fill:#FFD962;}
  .st432{fill:#FFDA63;}
  .st433{fill:#FFDB64;}
  .st434{fill:#FFDC65;}
  .st435{fill:#FFDD66;}
  .st436{fill:#FFDD67;}
  .st437{fill:#FFDE67;}
  .st438{fill:#FFDF68;}
  .st439{fill:#FFDF69;}
  .st440{fill:#FFE069;}
  .st441{fill:#FFE16A;}
  .st442{fill:#FFE16B;}
  .st443{fill:#FFE26C;}
  .st444{fill:#FFE36C;}
  .st445{fill:#FFE46D;}
  .st446{fill:#FFE46E;}
  .st447{fill:#FFE56F;}
  .st448{fill:#FFE66F;}
  .st449{fill:#FFE670;}
  .st450{fill:#FFE771;}
  .st451{fill:#FFE872;}
  .st452{fill:#FFE873;}
  .st453{fill:#FFE973;}
  .st454{fill:#FFEA74;}
  .st455{fill:#FFEB75;}
  .st456{fill:#FFEB76;}
  .st457{fill:#FFEC76;}
  .st458{fill:#FFED77;}
  .st459{fill:#FFED78;}
  .st460{fill:#FFEE79;}
  .st461{fill:#FFEF7A;}
  .st462{fill:#FFF07B;}
  .st463{fill:#FFF17C;}
  .st464{fill:#FFF17D;}
  .st465{fill:#FFF27E;}
  .st466{fill:#FFF37E;}
  .st467{fill:#FFF37F;}
  .st468{fill:#FFCF43;}
  .st469{fill:none;stroke:#DDDC00;stroke-width:1.0077;stroke-miterlimit:10;}
  .st470{fill:#E4D600;}
  .st471{fill:#E4D700;}
  .st472{fill:#E5D700;}
  .st473{fill:#E6D800;}
  .st474{fill:#E7D800;}
  .st475{fill:#E7D900;}
  .st476{fill:#E8D900;}
  .st477{fill:#E9DA00;}
  .st478{fill:#EADA00;}
  .st479{fill:#EADB00;}
  .st480{fill:#EBDB01;}
  .st481{fill:#EBDB05;}
  .st482{fill:#EBDC09;}
  .st483{fill:#ECDC0D;}
  .st484{fill:#ECDC10;}
  .st485{fill:#EDDD13;}
  .st486{fill:#EDDD16;}
  .st487{fill:#EDDD18;}
  .st488{fill:#EEDE1A;}
  .st489{fill:#EEDE1D;}
  .st490{fill:#EEDE1F;}
  .st491{fill:#EFDE21;}
  .st492{fill:#EFDF23;}
  .st493{fill:#F0DF25;}
  .st494{fill:#F0DF27;}
  .st495{fill:#F0E029;}
  .st496{fill:#F1E02A;}
  .st497{fill:#F1E02C;}
  .st498{fill:#F1E02E;}
  .st499{fill:#F2E130;}
  .st500{fill:#F2E131;}
  .st501{fill:#F2E133;}
  .st502{fill:#F3E234;}
  .st503{fill:#F3E236;}
  .st504{fill:#F3E237;}
  .st505{fill:#F4E339;}
  .st506{fill:#F4E33A;}
  .st507{fill:#F4E33C;}
  .st508{fill:#F5E43D;}
  .st509{fill:#F5E43E;}
  .st510{fill:#F5E440;}
  .st511{fill:#F6E541;}
  .st512{fill:#F6E542;}
  .st513{fill:#F6E544;}
  .st514{fill:#F7E545;}
  .st515{fill:#F7E646;}
  .st516{fill:#F8E648;}
  .st517{fill:#F8E749;}
  .st518{fill:#F8E74A;}
  .st519{fill:#F9E74C;}
  .st520{fill:#F9E84D;}
  .st521{fill:#F9E84E;}
  .st522{fill:#FAE84F;}
  .st523{fill:#FAE951;}
  .st524{fill:#FBE952;}
  .st525{fill:#FBE953;}
  .st526{fill:#FBEA54;}
  .st527{fill:#FCEA56;}
  .st528{fill:#FCEA57;}
  .st529{fill:#FCEB58;}
  .st530{fill:#FDEB59;}
  .st531{fill:#FDEB5A;}
  .st532{fill:#FEEC5B;}
  .st533{fill:#FEEC5D;}
  .st534{fill:#FEED5E;}
  .st535{fill:#FFED5F;}
  .st536{fill:#FFED60;}
  .st537{fill:#FFEE61;}
  .st538{fill:#FFEE62;}
  .st539{fill:#FFEE64;}
  .st540{fill:#FFEF65;}
  .st541{fill:#FFEF66;}
  .st542{fill:#FFEF67;}
  .st543{fill:#FFF068;}
  .st544{fill:#FFF069;}
  .st545{fill:#FFF06A;}
  .st546{fill:#FFF16C;}
  .st547{fill:#FFF16D;}
  .st548{fill:#FFF16E;}
  .st549{fill:#FFF26F;}
  .st550{fill:#FFF270;}
  .st551{fill:#FFF271;}
  .st552{fill:#FFF372;}
  .st553{fill:#FFF374;}
  .st554{fill:#DDDC00;}
  .st555{fill:none;stroke:#7EBF6C;stroke-width:1.0077;stroke-miterlimit:10;}
  .st556{fill:#78B927;}
  .st557{fill:#9DC418;}
  .st558{fill:#ABC908;}
  .st559{fill:#AFCA03;}
  .st560{fill:#B0CA02;}
  .st561{fill:#B1CB01;}
  .st562{fill:#7EBF6C;}
  .st563{fill:none;stroke:#00A0E0;stroke-width:1.0077;stroke-miterlimit:10;}
  .st564{fill:none;stroke:#00A0E0;stroke-width:1.0077;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
  .st565{fill:#00A9E5;}
  .st566{fill:#00ABE6;}
  .st567{fill:#00ACE7;}
  .st568{fill:#00ADE7;}
  .st569{fill:#00AEE8;}
  .st570{fill:#00AFE8;}
  .st571{fill:#00B0E8;}
  .st572{fill:#00B1E9;}
  .st573{fill:#00B2E9;}
  .st574{fill:#00B3EA;}
  .st575{fill:#00B4EA;}
  .st576{fill:#00B5EB;}
  .st577{fill:#06B5EB;}
  .st578{fill:#10B6EB;}
  .st579{fill:#17B6EB;}
  .st580{fill:#1DB6EB;}
  .st581{fill:#22B7EB;}
  .st582{fill:#26B7EC;}
  .st583{fill:#2AB8EC;}
  .st584{fill:#2EB8EC;}
  .st585{fill:#31B9EC;}
  .st586{fill:#34B9EC;}
  .st587{fill:#37BAEC;}
  .st588{fill:#3ABAED;}
  .st589{fill:#3DBAED;}
  .st590{fill:#40BBED;}
  .st591{fill:#42BBED;}
  .st592{fill:#45BCED;}
  .st593{fill:#47BCED;}
  .st594{fill:#49BDEE;}
  .st595{fill:#4BBDEE;}
  .st596{fill:#4EBEEE;}
  .st597{fill:#50BEEE;}
  .st598{fill:#52BFEE;}
  .st599{fill:#54BFEE;}
  .st600{fill:#56BFEE;}
  .st601{fill:#58C0EF;}
  .st602{fill:#5AC0EF;}
  .st603{fill:#5CC1EF;}
  .st604{fill:#5DC1EF;}
  .st605{fill:#5FC2EF;}
  .st606{fill:#61C2EF;}
  .st607{fill:#62C3F0;}
  .st608{fill:#64C3F0;}
  .st609{fill:#65C4F0;}
  .st610{fill:#67C4F0;}
  .st611{fill:#68C4F0;}
  .st612{fill:#6AC5F0;}
  .st613{fill:#6BC5F1;}
  .st614{fill:#6DC6F1;}
  .st615{fill:#6EC6F1;}
  .st616{fill:#6FC7F1;}
  .st617{fill:#71C7F1;}
  .st618{fill:#72C8F1;}
  .st619{fill:#74C8F2;}
  .st620{fill:#75C8F2;}
  .st621{fill:#76C9F2;}
  .st622{fill:#78C9F2;}
  .st623{fill:#79CAF2;}
  .st624{fill:#7ACAF2;}
  .st625{fill:#7BCBF3;}
  .st626{fill:#7DCBF3;}
  .st627{fill:#7ECCF3;}
  .st628{fill:#7FCCF3;}
  .st629{fill:#81CCF3;}
  .st630{fill:#82CDF3;}
  .st631{fill:#83CDF4;}
  .st632{fill:#84CEF4;}
  .st633{fill:#86CEF4;}
  .st634{fill:#87CFF4;}
  .st635{fill:#88CFF4;}
  .st636{fill:#89D0F4;}
  .st637{fill:#8AD0F4;}
  .st638{fill:#8CD0F5;}
  .st639{fill:#8DD1F5;}
  .st640{fill:#8ED1F5;}
  .st641{fill:#8FD2F5;}
  .st642{fill:#90D2F5;}
  .st643{fill:#91D3F5;}
  .st644{fill:#93D3F6;}
  .st645{fill:#94D4F6;}
  .st646{fill:#95D4F6;}
  .st647{fill:#96D4F6;}
  .st648{fill:#97D5F6;}
  .st649{fill:#98D5F6;}
  .st650{fill:#9AD6F7;}
  .st651{fill:#9BD6F7;}
  .st652{fill:#9CD7F7;}
  .st653{fill:#9DD7F7;}
  .st654{fill:#9ED8F7;}
  .st655{fill:#9FD8F7;}
  .st656{fill:#A0D9F8;}
  .st657{fill:#A1D9F8;}
  .st658{fill:#A2D9F8;}
  .st659{fill:#A4DAF8;}
  .st660{fill:#A5DAF8;}
  .st661{fill:#A6DBF8;}
  .st662{fill:#A7DBF8;}
  .st663{fill:#A8DCF8;}
  .st664{fill:#A9DCF9;}
  .st665{fill:#00A0E0;}
  .st666{fill:none;stroke:#E73E1C;stroke-width:1.0077;stroke-miterlimit:10;}
  .st667{fill:#E30B11;}
  .st668{fill:#E41412;}
  .st669{fill:#E41813;}
  .st670{fill:#E41A13;}
  .st671{fill:#E41E14;}
  .st672{fill:#E41F14;}
  .st673{fill:#E42115;}
  .st674{fill:#E52315;}
  .st675{fill:#E52415;}
  .st676{fill:#E52516;}
  .st677{fill:#E52716;}
  .st678{fill:#E52816;}
  .st679{fill:#E52A17;}
  .st680{fill:#E52B17;}
  .st681{fill:#E52C17;}
  .st682{fill:#E52D18;}
  .st683{fill:#E62E18;}
  .st684{fill:#E63018;}
  .st685{fill:#E63119;}
  .st686{fill:#E63219;}
  .st687{fill:#E63319;}
  .st688{fill:#E6341A;}
  .st689{fill:#E6351A;}
  .st690{fill:#E6371A;}
  .st691{fill:#E7381B;}
  .st692{fill:#E7391B;}
  .st693{fill:#E73A1B;}
  .st694{fill:#E73B1C;}
  .st695{fill:#E73C1C;}
  .st696{fill:#E73D1D;}
  .st697{fill:#E73F1D;}
  .st698{fill:#E8401D;}
  .st699{fill:#E8411E;}
  .st700{fill:#E8421E;}
  .st701{fill:#E8431F;}
  .st702{fill:#E8441F;}
  .st703{fill:#E8451F;}
  .st704{fill:#E94620;}
  .st705{fill:#E94720;}
  .st706{fill:#E94820;}
  .st707{fill:#E94921;}
  .st708{fill:#E94A21;}
  .st709{fill:#E94B22;}
  .st710{fill:#EA4C22;}
  .st711{fill:#EA4D22;}
  .st712{fill:#EA4E23;}
  .st713{fill:#EA4F23;}
  .st714{fill:#EA5024;}
  .st715{fill:#EA5124;}
  .st716{fill:#EA5225;}
  .st717{fill:#EA5325;}
  .st718{fill:#EA5426;}
  .st719{fill:#EB5526;}
  .st720{fill:#EB5627;}
  .st721{fill:#EB5727;}
  .st722{fill:#EB5828;}
  .st723{fill:#EB5928;}
  .st724{fill:#EB5A29;}
  .st725{fill:#EB5B29;}
  .st726{fill:#EB5C2A;}
  .st727{fill:#EB5D2A;}
  .st728{fill:#EC5E2B;}
  .st729{fill:#EC5F2B;}
  .st730{fill:#EC602C;}
  .st731{fill:#EC612C;}
  .st732{fill:#EC622D;}
  .st733{fill:#EC632D;}
  .st734{fill:#EC642E;}
  .st735{fill:#EC652E;}
  .st736{fill:#EC662F;}
  .st737{fill:#EC672F;}
  .st738{fill:#ED6830;}
  .st739{fill:#ED6930;}
  .st740{fill:#ED6A31;}
  .st741{fill:#ED6B31;}
  .st742{fill:#ED6C32;}
  .st743{fill:#ED6D32;}
  .st744{fill:#ED6E32;}
  .st745{fill:#EE6F33;}
  .st746{fill:#EE7033;}
  .st747{fill:#EE7034;}
  .st748{fill:#EE7134;}
  .st749{fill:#EE7234;}
  .st750{fill:#EE7335;}
  .st751{fill:#EE7435;}
  .st752{fill:#EF7536;}
  .st753{fill:#EF7636;}
  .st754{fill:#EF7737;}
  .st755{fill:#EF7837;}
  .st756{fill:#EF7938;}
  .st757{fill:#EF7A38;}
  .st758{fill:#EF7B39;}
  .st759{fill:#F07C39;}
  .st760{fill:#F07D3A;}
  .st761{fill:#F07E3A;}
  .st762{fill:#F07F3B;}
  .st763{fill:#F0803B;}
  .st764{fill:#F0813C;}
  .st765{fill:#F0823C;}
  .st766{fill:#F0823D;}
  .st767{fill:#F0833D;}
  .st768{fill:#F1843E;}
  .st769{fill:#F1853E;}
  .st770{fill:#F1863F;}
  .st771{fill:#F1873F;}
  .st772{fill:#F18840;}
  .st773{fill:#F18940;}
  .st774{fill:#F18941;}
  .st775{fill:#F18A41;}
  .st776{fill:#F18B42;}
  .st777{fill:#F28C42;}
  .st778{fill:#F28D43;}
  .st779{fill:#F28E44;}
  .st780{fill:#F28F44;}
  .st781{fill:#F29045;}
  .st782{fill:#F29146;}
  .st783{fill:#F29246;}
  .st784{fill:#F39347;}
  .st785{fill:#F39448;}
  .st786{fill:#F39548;}
  .st787{fill:#F39649;}
  .st788{fill:#F3974A;}
  .st789{fill:#F4984A;}
  .st790{fill:#F4994B;}
  .st791{fill:#F49A4B;}
  .st792{fill:#F49B4C;}
  .st793{fill:#F49C4D;}
  .st794{fill:#F59D4D;}
  .st795{fill:#F59E4E;}
  .st796{fill:#F59F4F;}
  .st797{fill:#F5A04F;}
  .st798{fill:#F5A050;}
  .st799{fill:#F5A150;}
  .st800{fill:#F5A251;}
  .st801{fill:#F6A351;}
  .st802{fill:#F6A452;}
  .st803{fill:#F6A553;}
  .st804{fill:#F6A654;}
  .st805{fill:#F6A754;}
  .st806{fill:#F6A855;}
  .st807{fill:#F7A956;}
  .st808{fill:#F7AA56;}
  .st809{fill:#F7AB57;}
  .st810{fill:#F7AC58;}
  .st811{fill:#F7AD59;}
  .st812{fill:#F7AE59;}
  .st813{fill:#E73E1C;}
  .st814{fill:none;stroke:#1C1B18;stroke-width:0.5;stroke-miterlimit:10;}


  .content-2-triangle {
    fill: var(--gray);

    stroke: var(--gray);
    stroke-width: 1%;
  }
</style>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, inject } from "vue";

// container element
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 550;
});
const isDarkTheme = ref(false);

/**
 *
 */
function onResize() {
  containerWidth.value = containerElement.clientWidth;
}

// ***

onMounted(async () => {
  window.addEventListener("resize", onResize);
  onResize();
  nextTick(onResize);
  window.setTimeout(onResize, 1500);

  //
  const htmlElement = document.querySelector("html");
  if (htmlElement.classList.contains("dark-theme")) {
    isDarkTheme.value = true;
  }
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
